// generated with @7nohe/openapi-react-query-codegen@1.6.2 

import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AcquisitionTypesService, AlertsService, AnalyticsControllerService, AttributesService, CarouselControllerService, CommentsService, CompanyLogoService, CustomerContactService, GlobalSearchService, KanbanService, LeadAssignmentService, LeadAttributesService, LeadCrudService, LeadImportService, LeadRemovalService, LeadRetrievalService, LeadSearchService, LeadTaskManagementService, LogoService, MinIoFileStorageService, OffersService, PasswordResetService, PrefixConfigControllerService, RegistrationService, ReportsService, StatisticsService, TaskAssignmentService, TaskRemovalService, TaskRetrievalService, TasksService, UserAvatarControllerService, UserService, ValidationService, WelcomeImageControllerService } from "../requests/services.gen";
import { AcquisitionTypeDTO, AlertDTO, AssignLeadsToTaskRequest, AssignTasksToLeadRequest, AttributeDTO, CommentDTO, CustomerContactFormDTO, DetachLeadsFromTaskRequest, DetachTasksFromLeadRequest, KanbanStatusUpdateRequest, LeadDTO, LeadFilterRequest, OfferDTO, PredefinedLeadAttributeDTO, RegistrationCompleteDTO, RegistrationRequestDTO, ResetPasswordDTO, ResetRequestDTO, SelectAvatarRequest, TaskDTO, UpdatePrefixValueRequest, UserDTO, UserEventRequest, UserUpdateDTO } from "../requests/types.gen";
import * as Common from "./common";
/**
* Pobierz informacje o aktualnie zalogowanym użytkowniku
* Zwraca szczegółowe informacje o aktualnie zalogowanym użytkowniku w obrębie jego domeny
* @returns CurrentUserInfoDTO Informacje pobrane pomyślnie
* @throws ApiError
*/
export const useUserServiceGetApiUserMe = <TData = Common.UserServiceGetApiUserMeDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseUserServiceGetApiUserMeKeyFn(queryKey), queryFn: () => UserService.getApiUserMe() as TData, ...options });
/**
* Pobierz użytkowników w domenie
* Zwraca listę wszystkich użytkowników w domenie aktualnie zalogowanego użytkownika
* @returns CurrentUserInfoDTO OK
* @throws ApiError
*/
export const useUserServiceGetApiUserDomain = <TData = Common.UserServiceGetApiUserDomainDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseUserServiceGetApiUserDomainKeyFn(queryKey), queryFn: () => UserService.getApiUserDomain() as TData, ...options });
/**
* Pobierz zadanie po ID
* Zwraca szczegóły konkretnego zadania na podstawie jego identyfikatora
* @param data The data for the request.
* @param data.id Identyfikator zadania
* @returns TaskDTO Zadanie zostało pomyślnie pobrane
* @throws ApiError
*/
export const useTasksServiceGetApiTasksById = <TData = Common.TasksServiceGetApiTasksByIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ id }: {
  id: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksByIdKeyFn({ id }, queryKey), queryFn: () => TasksService.getApiTasksById({ id }) as TData, ...options });
/**
* Pobierz wszystkie zadania
* Zwraca listę wszystkich zadań w systemie
* @returns TaskDTO Lista zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasks = <TData = Common.TasksServiceGetApiTasksDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksKeyFn(queryKey), queryFn: () => TasksService.getApiTasks() as TData, ...options });
/**
* Pobierz historię zmian zadania
* Zwraca pełną historię zmian dla określonego zadania, posortowaną od najnowszych do najstarszych
* @param data The data for the request.
* @param data.taskId Identyfikator zadania
* @returns TaskHistoryDTO Historia zadania została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksByTaskIdHistory = <TData = Common.TasksServiceGetApiTasksByTaskIdHistoryDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ taskId }: {
  taskId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksByTaskIdHistoryKeyFn({ taskId }, queryKey), queryFn: () => TasksService.getApiTasksByTaskIdHistory({ taskId }) as TData, ...options });
/**
* Pobierz nieprzypisane zadania
* Zwraca listę zadań które nie są przypisane do żadnego użytkownika
* @returns TaskDTO Lista nieprzypisanych zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksUnassigned = <TData = Common.TasksServiceGetApiTasksUnassignedDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksUnassignedKeyFn(queryKey), queryFn: () => TasksService.getApiTasksUnassigned() as TData, ...options });
/**
* Pobierz zadania po statusie
* Zwraca listę zadań o określonym statusie
* @param data The data for the request.
* @param data.status Status zadań do wyszukania
* @returns TaskDTO Lista zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStatusByStatus = <TData = Common.TasksServiceGetApiTasksStatusByStatusDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ status }: {
  status: "TODO" | "IN_PROGRESS" | "CANCELED" | "DONE";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStatusByStatusKeyFn({ status }, queryKey), queryFn: () => TasksService.getApiTasksStatusByStatus({ status }) as TData, ...options });
/**
* Sprawdź czy użytkownik ma przypisane zadania (ADMIN)
* Sprawdza czy określony użytkownik ma jakiekolwiek przypisane zadania
* @param data The data for the request.
* @param data.keycloakUserId Identyfikator użytkownika w Keycloak
* @returns boolean Status został pomyślnie sprawdzony
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStatsUserByKeycloakUserIdHasAssigned = <TData = Common.TasksServiceGetApiTasksStatsUserByKeycloakUserIdHasAssignedDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ keycloakUserId }: {
  keycloakUserId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStatsUserByKeycloakUserIdHasAssignedKeyFn({ keycloakUserId }, queryKey), queryFn: () => TasksService.getApiTasksStatsUserByKeycloakUserIdHasAssigned({ keycloakUserId }) as TData, ...options });
/**
* Liczba zadań utworzonych przez użytkownika (ADMIN)
* Zwraca liczbę zadań utworzonych przez określonego użytkownika
* @param data The data for the request.
* @param data.keycloakUserId Identyfikator użytkownika w Keycloak
* @returns number Liczba zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStatsUserByKeycloakUserIdCreatedCount = <TData = Common.TasksServiceGetApiTasksStatsUserByKeycloakUserIdCreatedCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ keycloakUserId }: {
  keycloakUserId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStatsUserByKeycloakUserIdCreatedCountKeyFn({ keycloakUserId }, queryKey), queryFn: () => TasksService.getApiTasksStatsUserByKeycloakUserIdCreatedCount({ keycloakUserId }) as TData, ...options });
/**
* Liczba zadań przypisanych do użytkownika (ADMIN)
* Zwraca liczbę zadań przypisanych do określonego użytkownika
* @param data The data for the request.
* @param data.keycloakUserId Identyfikator użytkownika w Keycloak
* @returns number Liczba zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStatsUserByKeycloakUserIdAssignedCount = <TData = Common.TasksServiceGetApiTasksStatsUserByKeycloakUserIdAssignedCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ keycloakUserId }: {
  keycloakUserId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStatsUserByKeycloakUserIdAssignedCountKeyFn({ keycloakUserId }, queryKey), queryFn: () => TasksService.getApiTasksStatsUserByKeycloakUserIdAssignedCount({ keycloakUserId }) as TData, ...options });
/**
* Całkowita liczba zadań (ADMIN)
* Zwraca całkowitą liczbę zadań w systemie
* @returns number Całkowita liczba zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStatsTotalCount = <TData = Common.TasksServiceGetApiTasksStatsTotalCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStatsTotalCountKeyFn(queryKey), queryFn: () => TasksService.getApiTasksStatsTotalCount() as TData, ...options });
/**
* Liczba zadań według statusu (ADMIN)
* Zwraca liczbę zadań o określonym statusie
* @param data The data for the request.
* @param data.status Status zadań do zliczenia
* @returns number Liczba zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStatsStatusByStatusCount = <TData = Common.TasksServiceGetApiTasksStatsStatusByStatusCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ status }: {
  status: "TODO" | "IN_PROGRESS" | "CANCELED" | "DONE";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStatsStatusByStatusCountKeyFn({ status }, queryKey), queryFn: () => TasksService.getApiTasksStatsStatusByStatusCount({ status }) as TData, ...options });
/**
* Liczba zadań według priorytetu (ADMIN)
* Zwraca liczbę zadań o określonym priorytecie
* @param data The data for the request.
* @param data.priority Priorytet zadań do zliczenia
* @returns number Liczba zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStatsPriorityByPriorityCount = <TData = Common.TasksServiceGetApiTasksStatsPriorityByPriorityCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ priority }: {
  priority: "A" | "B" | "C" | "D" | "E";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStatsPriorityByPriorityCountKeyFn({ priority }, queryKey), queryFn: () => TasksService.getApiTasksStatsPriorityByPriorityCount({ priority }) as TData, ...options });
/**
* Sprawdź czy aktualnie zalogowany użytkownik ma przypisane zadania
* @returns boolean OK
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStatsMyHasAssigned = <TData = Common.TasksServiceGetApiTasksStatsMyHasAssignedDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStatsMyHasAssignedKeyFn(queryKey), queryFn: () => TasksService.getApiTasksStatsMyHasAssigned() as TData, ...options });
/**
* Liczba zadań utworzonych przez aktualnie zalogowanego użytkownika
* @returns number OK
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStatsMyCreatedCount = <TData = Common.TasksServiceGetApiTasksStatsMyCreatedCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStatsMyCreatedCountKeyFn(queryKey), queryFn: () => TasksService.getApiTasksStatsMyCreatedCount() as TData, ...options });
/**
* Liczba zadań przypisanych do aktualnie zalogowanego użytkownika
* @returns number OK
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStatsMyAssignedCount = <TData = Common.TasksServiceGetApiTasksStatsMyAssignedCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStatsMyAssignedCountKeyFn(queryKey), queryFn: () => TasksService.getApiTasksStatsMyAssignedCount() as TData, ...options });
/**
* Pobiera kompleksowe statystyki zadań
* Zwraca obiekt zawierający liczbę zadań w każdym statusie, liczbę zadań przeterminowanych, liczbę zadań należących do aktualnie zalogowanego użytkownika oraz całkowitą liczbę zadań w systemie
* @returns TaskStatisticsDTO Statystyki zostały pomyślnie pobrane
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStatsComprehensive = <TData = Common.TasksServiceGetApiTasksStatsComprehensiveDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStatsComprehensiveKeyFn(queryKey), queryFn: () => TasksService.getApiTasksStatsComprehensive() as TData, ...options });
/**
* Pobierz zadania w przedziale dat rozpoczęcia
* Zwraca listę zadań których data rozpoczęcia mieści się w podanym przedziale
* @param data The data for the request.
* @param data.start Data początkowa (format ISO: yyyy-MM-ddTHH:mm:ss)
* @param data.end Data końcowa (format ISO: yyyy-MM-ddTHH:mm:ss)
* @returns TaskDTO Lista zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksStartDateBetween = <TData = Common.TasksServiceGetApiTasksStartDateBetweenDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ end, start }: {
  end: string;
  start: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksStartDateBetweenKeyFn({ end, start }, queryKey), queryFn: () => TasksService.getApiTasksStartDateBetween({ end, start }) as TData, ...options });
/**
* Pobierz ostatnio utworzone zadania
* Zwraca listę zadań utworzonych po podanej dacie
* @param data The data for the request.
* @param data.since Data od której szukać zadań (format ISO: yyyy-MM-ddTHH:mm:ss)
* @returns TaskDTO Lista ostatnio utworzonych zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksRecent = <TData = Common.TasksServiceGetApiTasksRecentDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ since }: {
  since: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksRecentKeyFn({ since }, queryKey), queryFn: () => TasksService.getApiTasksRecent({ since }) as TData, ...options });
/**
* Pobierz zadania po priorytecie
* Zwraca listę zadań o określonym priorytecie
* @param data The data for the request.
* @param data.priority Priorytet zadań do wyszukania
* @returns TaskDTO Lista zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksPriorityByPriority = <TData = Common.TasksServiceGetApiTasksPriorityByPriorityDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ priority }: {
  priority: "A" | "B" | "C" | "D" | "E";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksPriorityByPriorityKeyFn({ priority }, queryKey), queryFn: () => TasksService.getApiTasksPriorityByPriority({ priority }) as TData, ...options });
/**
* Pobierz zadania z zaawansowanym filtrowaniem i paginacją
* Zwraca paginowaną listę zadań z możliwością filtrowania, sortowania i różnych widoków
* @param data The data for the request.
* @param data.page
* @param data.size
* @param data.titleOrDescription
* @param data.clientId
* @param data.assignedToUserId
* @param data.taskType
* @param data.priority
* @param data.deadlineFrom
* @param data.deadlineTo
* @param data.createdFrom
* @param data.createdTo
* @param data.view
* @param data.sortBy
* @param data.sortDirection
* @returns TaskPagedResponse OK
* @throws ApiError
*/
export const useTasksServiceGetApiTasksPaginated = <TData = Common.TasksServiceGetApiTasksPaginatedDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ assignedToUserId, clientId, createdFrom, createdTo, deadlineFrom, deadlineTo, page, priority, size, sortBy, sortDirection, taskType, titleOrDescription, view }: {
  assignedToUserId?: string;
  clientId?: number;
  createdFrom?: string;
  createdTo?: string;
  deadlineFrom?: string;
  deadlineTo?: string;
  page?: number;
  priority?: "A" | "B" | "C" | "D" | "E";
  size?: number;
  sortBy?: "ID" | "TITLE" | "CLIENT_NAME" | "STATUS" | "PRIORITY" | "TASK_TYPE" | "ASSIGNED_TO" | "DEADLINE" | "CREATED_AT";
  sortDirection?: "ASC" | "DESC";
  taskType?: "EMAIL" | "PHONE" | "MEETING" | "MESSAGE" | "OTHER";
  titleOrDescription?: string;
  view?: "TODO" | "IN_PROGRESS" | "ALL" | "COMPLETED" | "OVERDUE" | "ASSIGNED_TO_ME";
} = {}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksPaginatedKeyFn({ assignedToUserId, clientId, createdFrom, createdTo, deadlineFrom, deadlineTo, page, priority, size, sortBy, sortDirection, taskType, titleOrDescription, view }, queryKey), queryFn: () => TasksService.getApiTasksPaginated({ assignedToUserId, clientId, createdFrom, createdTo, deadlineFrom, deadlineTo, page, priority, size, sortBy, sortDirection, taskType, titleOrDescription, view }) as TData, ...options });
/**
* Pobierz przeterminowane zadania
* Zwraca listę zadań których data zakończenia już minęła
* @returns TaskDTO Lista przeterminowanych zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksOverdue = <TData = Common.TasksServiceGetApiTasksOverdueDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksOverdueKeyFn(queryKey), queryFn: () => TasksService.getApiTasksOverdue() as TData, ...options });
/**
* Pobiera zadania utworzone przez aktualnie zalogowanego użytkownika
* @returns TaskDTO OK
* @throws ApiError
*/
export const useTasksServiceGetApiTasksMyCreated = <TData = Common.TasksServiceGetApiTasksMyCreatedDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksMyCreatedKeyFn(queryKey), queryFn: () => TasksService.getApiTasksMyCreated() as TData, ...options });
/**
* Pobiera zadania przypisane do aktualnie zalogowanego użytkownika
* @returns TaskDTO OK
* @throws ApiError
*/
export const useTasksServiceGetApiTasksMyAssigned = <TData = Common.TasksServiceGetApiTasksMyAssignedDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksMyAssignedKeyFn(queryKey), queryFn: () => TasksService.getApiTasksMyAssigned() as TData, ...options });
/**
* Pobiera zadania przypisane do aktualnie zalogowanego użytkownika o określonym statusie
* @param data The data for the request.
* @param data.status
* @returns TaskDTO OK
* @throws ApiError
*/
export const useTasksServiceGetApiTasksMyAssignedStatusByStatus = <TData = Common.TasksServiceGetApiTasksMyAssignedStatusByStatusDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ status }: {
  status: "TODO" | "IN_PROGRESS" | "CANCELED" | "DONE";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksMyAssignedStatusByStatusKeyFn({ status }, queryKey), queryFn: () => TasksService.getApiTasksMyAssignedStatusByStatus({ status }) as TData, ...options });
/**
* Pobiera przeterminowane zadania aktualnie zalogowanego użytkownika
* @returns TaskDTO OK
* @throws ApiError
*/
export const useTasksServiceGetApiTasksMyAssignedOverdue = <TData = Common.TasksServiceGetApiTasksMyAssignedOverdueDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksMyAssignedOverdueKeyFn(queryKey), queryFn: () => TasksService.getApiTasksMyAssignedOverdue() as TData, ...options });
/**
* Pobierz zadania w przedziale dat zakończenia
* Zwraca listę zadań których data zakończenia mieści się w podanym przedziale
* @param data The data for the request.
* @param data.start Data początkowa (format ISO: yyyy-MM-ddTHH:mm:ss)
* @param data.end Data końcowa (format ISO: yyyy-MM-ddTHH:mm:ss)
* @returns TaskDTO Lista zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksEndDateBetween = <TData = Common.TasksServiceGetApiTasksEndDateBetweenDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ end, start }: {
  end: string;
  start: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksEndDateBetweenKeyFn({ end, start }, queryKey), queryFn: () => TasksService.getApiTasksEndDateBetween({ end, start }) as TData, ...options });
/**
* Pobierz zadania w przedziale dat utworzenia
* Zwraca listę zadań których data utworzenia mieści się w podanym przedziale
* @param data The data for the request.
* @param data.start Data początkowa (format ISO: yyyy-MM-ddTHH:mm:ss)
* @param data.end Data końcowa (format ISO: yyyy-MM-ddTHH:mm:ss)
* @returns TaskDTO Lista zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksCreatedAtBetween = <TData = Common.TasksServiceGetApiTasksCreatedAtBetweenDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ end, start }: {
  end: string;
  start: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksCreatedAtBetweenKeyFn({ end, start }, queryKey), queryFn: () => TasksService.getApiTasksCreatedAtBetween({ end, start }) as TData, ...options });
/**
* Pobierz zadania utworzone przez użytkownika (ADMIN)
* Zwraca listę zadań utworzonych przez określonego użytkownika
* @param data The data for the request.
* @param data.keycloakUserId Identyfikator użytkownika w Keycloak
* @returns TaskDTO Lista zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksCreatedByByKeycloakUserId = <TData = Common.TasksServiceGetApiTasksCreatedByByKeycloakUserIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ keycloakUserId }: {
  keycloakUserId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksCreatedByByKeycloakUserIdKeyFn({ keycloakUserId }, queryKey), queryFn: () => TasksService.getApiTasksCreatedByByKeycloakUserId({ keycloakUserId }) as TData, ...options });
/**
* Pobierz zadania przypisane do użytkownika (ADMIN)
* Zwraca listę zadań przypisanych do określonego użytkownika
* @param data The data for the request.
* @param data.keycloakUserId Identyfikator użytkownika w Keycloak
* @returns TaskDTO Lista zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksAssignedToByKeycloakUserId = <TData = Common.TasksServiceGetApiTasksAssignedToByKeycloakUserIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ keycloakUserId }: {
  keycloakUserId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksAssignedToByKeycloakUserIdKeyFn({ keycloakUserId }, queryKey), queryFn: () => TasksService.getApiTasksAssignedToByKeycloakUserId({ keycloakUserId }) as TData, ...options });
/**
* Pobierz zadania przypisane do użytkownika o określonym statusie (ADMIN)
* Zwraca listę zadań przypisanych do użytkownika z określonym statusem
* @param data The data for the request.
* @param data.keycloakUserId Identyfikator użytkownika w Keycloak
* @param data.status Status zadań do wyszukania
* @returns TaskDTO Lista zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksAssignedToByKeycloakUserIdStatusByStatus = <TData = Common.TasksServiceGetApiTasksAssignedToByKeycloakUserIdStatusByStatusDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ keycloakUserId, status }: {
  keycloakUserId: string;
  status: "TODO" | "IN_PROGRESS" | "CANCELED" | "DONE";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksAssignedToByKeycloakUserIdStatusByStatusKeyFn({ keycloakUserId, status }, queryKey), queryFn: () => TasksService.getApiTasksAssignedToByKeycloakUserIdStatusByStatus({ keycloakUserId, status }) as TData, ...options });
/**
* Pobierz przeterminowane zadania użytkownika (ADMIN)
* Zwraca listę przeterminowanych zadań przypisanych do określonego użytkownika
* @param data The data for the request.
* @param data.keycloakUserId Identyfikator użytkownika w Keycloak
* @returns TaskDTO Lista przeterminowanych zadań została pomyślnie pobrana
* @throws ApiError
*/
export const useTasksServiceGetApiTasksAssignedToByKeycloakUserIdOverdue = <TData = Common.TasksServiceGetApiTasksAssignedToByKeycloakUserIdOverdueDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ keycloakUserId }: {
  keycloakUserId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTasksServiceGetApiTasksAssignedToByKeycloakUserIdOverdueKeyFn({ keycloakUserId }, queryKey), queryFn: () => TasksService.getApiTasksAssignedToByKeycloakUserIdOverdue({ keycloakUserId }) as TData, ...options });
/**
* Pobierz predefiniowany atrybut po ID
* Zwraca szczegóły predefiniowanego atrybutu o podanym identyfikatorze
* @param data The data for the request.
* @param data.id Identyfikator predefiniowanego atrybutu
* @returns PredefinedLeadAttributeDTO Predefiniowany atrybut został pomyślnie znaleziony
* @throws ApiError
*/
export const useLeadAttributesServiceGetApiPredefinedLeadAttributesById = <TData = Common.LeadAttributesServiceGetApiPredefinedLeadAttributesByIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ id }: {
  id: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadAttributesServiceGetApiPredefinedLeadAttributesByIdKeyFn({ id }, queryKey), queryFn: () => LeadAttributesService.getApiPredefinedLeadAttributesById({ id }) as TData, ...options });
/**
* Pobierz wszystkie predefiniowane atrybuty
* Zwraca listę wszystkich predefiniowanych atrybutów dla leadów w domenie użytkownika
* @returns PredefinedLeadAttributeDTO Lista predefiniowanych atrybutów została pomyślnie pobrana
* @throws ApiError
*/
export const useLeadAttributesServiceGetApiPredefinedLeadAttributes = <TData = Common.LeadAttributesServiceGetApiPredefinedLeadAttributesDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadAttributesServiceGetApiPredefinedLeadAttributesKeyFn(queryKey), queryFn: () => LeadAttributesService.getApiPredefinedLeadAttributes() as TData, ...options });
/**
* Pobierz predefiniowane atrybuty dla domeny użytkownika
* Zwraca listę predefiniowanych atrybutów dla kontaktów w domenie użytkownika
* @returns PredefinedLeadAttributeDTO Lista predefiniowanych atrybutów została pomyślnie pobrana
* @throws ApiError
*/
export const useLeadAttributesServiceGetApiLeadContactsPredefinedAttributes = <TData = Common.LeadAttributesServiceGetApiLeadContactsPredefinedAttributesDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadAttributesServiceGetApiLeadContactsPredefinedAttributesKeyFn(queryKey), queryFn: () => LeadAttributesService.getApiLeadContactsPredefinedAttributes() as TData, ...options });
/**
* Pobierz ofertę po ID
* @param data The data for the request.
* @param data.id
* @returns OfferDTO OK
* @throws ApiError
*/
export const useOffersServiceGetApiOffersById = <TData = Common.OffersServiceGetApiOffersByIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ id }: {
  id: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseOffersServiceGetApiOffersByIdKeyFn({ id }, queryKey), queryFn: () => OffersService.getApiOffersById({ id }) as TData, ...options });
/**
* Pobierz wszystkie oferty
* @returns OfferDTO OK
* @throws ApiError
*/
export const useOffersServiceGetApiOffers = <TData = Common.OffersServiceGetApiOffersDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseOffersServiceGetApiOffersKeyFn(queryKey), queryFn: () => OffersService.getApiOffers() as TData, ...options });
/**
* Pobierz oferty po typie
* @param data The data for the request.
* @param data.type
* @returns OfferDTO OK
* @throws ApiError
*/
export const useOffersServiceGetApiOffersTypeByType = <TData = Common.OffersServiceGetApiOffersTypeByTypeDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ type }: {
  type: "PRODUCT" | "SERVICE";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseOffersServiceGetApiOffersTypeByTypeKeyFn({ type }, queryKey), queryFn: () => OffersService.getApiOffersTypeByType({ type }) as TData, ...options });
/**
* Wyszukaj oferty po nazwie
* @param data The data for the request.
* @param data.name
* @returns OfferDTO OK
* @throws ApiError
*/
export const useOffersServiceGetApiOffersSearch = <TData = Common.OffersServiceGetApiOffersSearchDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ name }: {
  name: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseOffersServiceGetApiOffersSearchKeyFn({ name }, queryKey), queryFn: () => OffersService.getApiOffersSearch({ name }) as TData, ...options });
/**
* Pobierz kontakt po ID
* Zwraca szczegóły kontaktu o podanym identyfikatorze
* @param data The data for the request.
* @param data.id Identyfikator kontaktu
* @returns LeadDTO Kontakt został pomyślnie znaleziony
* @throws ApiError
*/
export const useLeadCrudServiceGetApiLeadContactsById = <TData = Common.LeadCrudServiceGetApiLeadContactsByIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ id }: {
  id: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadCrudServiceGetApiLeadContactsByIdKeyFn({ id }, queryKey), queryFn: () => LeadCrudService.getApiLeadContactsById({ id }) as TData, ...options });
/**
* Pobierz wszystkie kontakty
* Zwraca listę wszystkich kontaktów typu lead
* @returns LeadDTO Lista kontaktów została pomyślnie pobrana
* @throws ApiError
*/
export const useLeadCrudServiceGetApiLeadContacts = <TData = Common.LeadCrudServiceGetApiLeadContactsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadCrudServiceGetApiLeadContactsKeyFn(queryKey), queryFn: () => LeadCrudService.getApiLeadContacts() as TData, ...options });
/**
* Pobierz kontakty z zaawansowanym filtrowaniem i paginacją
* Zwraca paginowaną listę kontaktów z możliwością filtrowania i sortowania
* @param data The data for the request.
* @param data.page
* @param data.size
* @param data.searchTerm
* @param data.acquisitionTypeId
* @param data.offer
* @param data.createdFrom
* @param data.createdTo
* @param data.sortBy
* @param data.sortDirection
* @returns LeadPagedResponse Paginowana lista kontaktów została pomyślnie pobrana
* @throws ApiError
*/
export const useLeadCrudServiceGetApiLeadContactsPaginated = <TData = Common.LeadCrudServiceGetApiLeadContactsPaginatedDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ acquisitionTypeId, createdFrom, createdTo, offer, page, searchTerm, size, sortBy, sortDirection }: {
  acquisitionTypeId?: number;
  createdFrom?: string;
  createdTo?: string;
  offer?: number;
  page?: number;
  searchTerm?: string;
  size?: number;
  sortBy?: "ID" | "CREATED_AT" | "EMAIL" | "PHONE" | "FIRST_NAME" | "LAST_NAME" | "NAME" | "CITY" | "NIP" | "OFFER" | "ACQUISITION_TYPE";
  sortDirection?: "ASC" | "DESC";
} = {}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadCrudServiceGetApiLeadContactsPaginatedKeyFn({ acquisitionTypeId, createdFrom, createdTo, offer, page, searchTerm, size, sortBy, sortDirection }, queryKey), queryFn: () => LeadCrudService.getApiLeadContactsPaginated({ acquisitionTypeId, createdFrom, createdTo, offer, page, searchTerm, size, sortBy, sortDirection }) as TData, ...options });
/**
* Pobierz dane dla tablicy kanban
* Zwraca zadania dla tablicy kanban z filtrowaniem po zakresie dat i opcjonalnie po użytkownikach
* @param data The data for the request.
* @param data.startDate Data początkowa zakresu (format: yyyy-MM-ddTHH:mm:ss)
* @param data.endDate Data końcowa zakresu (format: yyyy-MM-ddTHH:mm:ss)
* @param data.userIds Lista ID użytkowników do filtrowania (opcjonalne)
* @returns TaskWithKanbanInfoDTO Dane tablicy kanban zostały pomyślnie pobrane
* @throws ApiError
*/
export const useKanbanServiceGetApiKanbanBoard = <TData = Common.KanbanServiceGetApiKanbanBoardDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ endDate, startDate, userIds }: {
  endDate: string;
  startDate: string;
  userIds?: string[];
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseKanbanServiceGetApiKanbanBoardKeyFn({ endDate, startDate, userIds }, queryKey), queryFn: () => KanbanService.getApiKanbanBoard({ endDate, startDate, userIds }) as TData, ...options });
/**
* Pobierz zadania kanban dla konkretnego statusu
* @param data The data for the request.
* @param data.status Status zadań do wyszukania
* @returns TaskWithKanbanInfoDTO Zadania kanban dla statusu zostały pomyślnie pobrane
* @throws ApiError
*/
export const useKanbanServiceGetApiKanbanBoardStatusByStatus = <TData = Common.KanbanServiceGetApiKanbanBoardStatusByStatusDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ status }: {
  status: "TODO" | "IN_PROGRESS" | "CANCELED" | "DONE";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseKanbanServiceGetApiKanbanBoardStatusByStatusKeyFn({ status }, queryKey), queryFn: () => KanbanService.getApiKanbanBoardStatusByStatus({ status }) as TData, ...options });
/**
* Pobierz wartość prefiksu
* Zwraca wartość prefiksu dla danego typu
* @param data The data for the request.
* @param data.prefixType
* @returns string Wartość prefiksu została pomyślnie pobrana
* @throws ApiError
*/
export const usePrefixConfigControllerServiceGetApiConfigPrefixByPrefixType = <TData = Common.PrefixConfigControllerServiceGetApiConfigPrefixByPrefixTypeDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ prefixType }: {
  prefixType: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UsePrefixConfigControllerServiceGetApiConfigPrefixByPrefixTypeKeyFn({ prefixType }, queryKey), queryFn: () => PrefixConfigControllerService.getApiConfigPrefixByPrefixType({ prefixType }) as TData, ...options });
/**
* Pobierz konfigurację prefiksów
* Zwraca aktualną konfigurację prefiksów dla zadań i leadów
* @returns PrefixConfigDTO Konfiguracja prefiksów została pomyślnie pobrana
* @throws ApiError
*/
export const usePrefixConfigControllerServiceGetApiConfigPrefix = <TData = Common.PrefixConfigControllerServiceGetApiConfigPrefixDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UsePrefixConfigControllerServiceGetApiConfigPrefixKeyFn(queryKey), queryFn: () => PrefixConfigControllerService.getApiConfigPrefix() as TData, ...options });
/**
* Pobierz wszystkie konfiguracje prefiksów
* Zwraca wszystkie dostępne konfiguracje prefiksów
* @returns PrefixConfiguration Lista konfiguracji prefiksów została pomyślnie pobrana
* @throws ApiError
*/
export const usePrefixConfigControllerServiceGetApiConfigPrefixAll = <TData = Common.PrefixConfigControllerServiceGetApiConfigPrefixAllDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UsePrefixConfigControllerServiceGetApiConfigPrefixAllKeyFn(queryKey), queryFn: () => PrefixConfigControllerService.getApiConfigPrefixAll() as TData, ...options });
/**
* Pobierz komentarz po ID
* @param data The data for the request.
* @param data.id
* @returns CommentDTO OK
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsById = <TData = Common.CommentsServiceGetApiCommentsByIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ id }: {
  id: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsByIdKeyFn({ id }, queryKey), queryFn: () => CommentsService.getApiCommentsById({ id }) as TData, ...options });
/**
* Pobierz komentarze dla określonego obiektu
* @param data The data for the request.
* @param data.objectId
* @param data.objectType
* @returns CommentDTO OK
* @throws ApiError
*/
export const useCommentsServiceGetApiComments = <TData = Common.CommentsServiceGetApiCommentsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ objectId, objectType }: {
  objectId: number;
  objectType: "OFFER" | "LEAD" | "TASK";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsKeyFn({ objectId, objectType }, queryKey), queryFn: () => CommentsService.getApiComments({ objectId, objectType }) as TData, ...options });
/**
* Policz komentarze użytkownika (ADMIN)
* @param data The data for the request.
* @param data.userId
* @returns number OK
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsUserByUserIdCount = <TData = Common.CommentsServiceGetApiCommentsUserByUserIdCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ userId }: {
  userId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsUserByUserIdCountKeyFn({ userId }, queryKey), queryFn: () => CommentsService.getApiCommentsUserByUserIdCount({ userId }) as TData, ...options });
/**
* Pobierz wszystkie komentarze aktualnie zalogowanego użytkownika
* Zwraca wszystkie komentarze utworzone przez aktualnie zalogowanego użytkownika.
* Komentarze są sortowane od najnowszych do najstarszych.
*
* @returns CommentDTO Lista komentarzy użytkownika
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsMy = <TData = Common.CommentsServiceGetApiCommentsMyDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsMyKeyFn(queryKey), queryFn: () => CommentsService.getApiCommentsMy() as TData, ...options });
/**
* Policz komentarze aktualnego użytkownika
* Zwraca liczbę komentarzy utworzonych przez aktualnie zalogowanego użytkownika
* @returns unknown Liczba komentarzy użytkownika
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsMyCount = <TData = Common.CommentsServiceGetApiCommentsMyCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsMyCountKeyFn(queryKey), queryFn: () => CommentsService.getApiCommentsMyCount() as TData, ...options });
/**
* Pobierz komentarze gdzie użytkownik został wzmiankowany
* Zwraca wszystkie komentarze gdzie określony użytkownik został wzmiankowany.
* Komentarze są sortowane od najnowszych.
*
* @param data The data for the request.
* @param data.userId ID użytkownika Keycloak
* @returns CommentDTO Lista komentarzy z wzmiankami
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsMentionsUserByUserId = <TData = Common.CommentsServiceGetApiCommentsMentionsUserByUserIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ userId }: {
  userId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsMentionsUserByUserIdKeyFn({ userId }, queryKey), queryFn: () => CommentsService.getApiCommentsMentionsUserByUserId({ userId }) as TData, ...options });
/**
* Sprawdź czy użytkownik ma wzmianki (ADMIN)
* @param data The data for the request.
* @param data.userId
* @returns boolean OK
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsMentionsUserByUserIdExists = <TData = Common.CommentsServiceGetApiCommentsMentionsUserByUserIdExistsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ userId }: {
  userId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsMentionsUserByUserIdExistsKeyFn({ userId }, queryKey), queryFn: () => CommentsService.getApiCommentsMentionsUserByUserIdExists({ userId }) as TData, ...options });
/**
* Policz wzmianki użytkownika (ADMIN)
* @param data The data for the request.
* @param data.userId
* @returns number OK
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsMentionsUserByUserIdCount = <TData = Common.CommentsServiceGetApiCommentsMentionsUserByUserIdCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ userId }: {
  userId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsMentionsUserByUserIdCountKeyFn({ userId }, queryKey), queryFn: () => CommentsService.getApiCommentsMentionsUserByUserIdCount({ userId }) as TData, ...options });
/**
* Pobierz komentarze z wzmiankami dla określonego obiektu
* Zwraca komentarze zawierające wzmianki użytkowników dla określonego obiektu
* @param data The data for the request.
* @param data.objectId ID obiektu
* @param data.objectType Typ obiektu
* @returns CommentDTO OK
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsMentionsObjectByObjectId = <TData = Common.CommentsServiceGetApiCommentsMentionsObjectByObjectIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ objectId, objectType }: {
  objectId: number;
  objectType: "OFFER" | "LEAD" | "TASK";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsMentionsObjectByObjectIdKeyFn({ objectId, objectType }, queryKey), queryFn: () => CommentsService.getApiCommentsMentionsObjectByObjectId({ objectId, objectType }) as TData, ...options });
/**
* Policz wzmianki dla obiektu
* Zwraca liczbę komentarzy z wzmiankami dla określonego obiektu
* @param data The data for the request.
* @param data.objectId ID obiektu
* @param data.objectType Typ obiektu
* @returns number OK
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsMentionsObjectByObjectIdCount = <TData = Common.CommentsServiceGetApiCommentsMentionsObjectByObjectIdCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ objectId, objectType }: {
  objectId: number;
  objectType: "OFFER" | "LEAD" | "TASK";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsMentionsObjectByObjectIdCountKeyFn({ objectId, objectType }, queryKey), queryFn: () => CommentsService.getApiCommentsMentionsObjectByObjectIdCount({ objectId, objectType }) as TData, ...options });
/**
* Pobierz komentarze gdzie aktualny użytkownik został wzmiankowany
* Zwraca wszystkie komentarze gdzie aktualnie zalogowany użytkownik został wzmiankowany.
* Komentarze są sortowane od najnowszych.
*
* @returns CommentDTO Lista komentarzy z wzmiankami
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsMentionsMy = <TData = Common.CommentsServiceGetApiCommentsMentionsMyDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsMentionsMyKeyFn(queryKey), queryFn: () => CommentsService.getApiCommentsMentionsMy() as TData, ...options });
/**
* Sprawdź czy aktualny użytkownik ma wzmianki
* Sprawdza czy aktualnie zalogowany użytkownik ma jakiekolwiek wzmianki w komentarzach
* @returns boolean OK
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsMentionsMyExists = <TData = Common.CommentsServiceGetApiCommentsMentionsMyExistsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsMentionsMyExistsKeyFn(queryKey), queryFn: () => CommentsService.getApiCommentsMentionsMyExists() as TData, ...options });
/**
* Policz wzmianki aktualnego użytkownika
* Zwraca liczbę komentarzy gdzie aktualnie zalogowany użytkownik został wzmiankowany
* @returns unknown Liczba wzmiankowanych komentarzy
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsMentionsMyCount = <TData = Common.CommentsServiceGetApiCommentsMentionsMyCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsMentionsMyCountKeyFn(queryKey), queryFn: () => CommentsService.getApiCommentsMentionsMyCount() as TData, ...options });
/**
* Pobierz wszystkie komentarze z wzmiankami
* Zwraca wszystkie komentarze w systemie które zawierają wzmianki użytkowników
* @returns CommentDTO OK
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsMentionsAll = <TData = Common.CommentsServiceGetApiCommentsMentionsAllDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsMentionsAllKeyFn(queryKey), queryFn: () => CommentsService.getApiCommentsMentionsAll() as TData, ...options });
/**
* Pobierz wszystkie komentarze w systemie (ADMIN)
* @returns CommentDTO OK
* @throws ApiError
*/
export const useCommentsServiceGetApiCommentsAll = <TData = Common.CommentsServiceGetApiCommentsAllDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCommentsServiceGetApiCommentsAllKeyFn(queryKey), queryFn: () => CommentsService.getApiCommentsAll() as TData, ...options });
/**
* Pobierz atrybut po ID
* @param data The data for the request.
* @param data.id
* @returns AttributeDTO OK
* @throws ApiError
*/
export const useAttributesServiceGetApiAttributesById = <TData = Common.AttributesServiceGetApiAttributesByIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ id }: {
  id: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAttributesServiceGetApiAttributesByIdKeyFn({ id }, queryKey), queryFn: () => AttributesService.getApiAttributesById({ id }) as TData, ...options });
/**
* Pobierz wszystkie atrybuty
* @returns AttributeDTO OK
* @throws ApiError
*/
export const useAttributesServiceGetApiAttributes = <TData = Common.AttributesServiceGetApiAttributesDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAttributesServiceGetApiAttributesKeyFn(queryKey), queryFn: () => AttributesService.getApiAttributes() as TData, ...options });
/**
* Pobierz atrybuty dla określonego obiektu
* @param data The data for the request.
* @param data.objectType
* @param data.objectId
* @returns AttributeDTO OK
* @throws ApiError
*/
export const useAttributesServiceGetApiAttributesObjectByObjectTypeByObjectId = <TData = Common.AttributesServiceGetApiAttributesObjectByObjectTypeByObjectIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ objectId, objectType }: {
  objectId: number;
  objectType: "OFFER" | "LEAD" | "TASK";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAttributesServiceGetApiAttributesObjectByObjectTypeByObjectIdKeyFn({ objectId, objectType }, queryKey), queryFn: () => AttributesService.getApiAttributesObjectByObjectTypeByObjectId({ objectId, objectType }) as TData, ...options });
/**
* Pobierz wszystkie typy pozyskania
* @returns AcquisitionTypeDTO OK
* @throws ApiError
*/
export const useAcquisitionTypesServiceGetAcquisitionTypes = <TData = Common.AcquisitionTypesServiceGetAcquisitionTypesDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAcquisitionTypesServiceGetAcquisitionTypesKeyFn(queryKey), queryFn: () => AcquisitionTypesService.getAcquisitionTypes() as TData, ...options });
/**
* @returns WelcomeImageResponse OK
* @throws ApiError
*/
export const useWelcomeImageControllerServiceGetApiWelcomeImagesToday = <TData = Common.WelcomeImageControllerServiceGetApiWelcomeImagesTodayDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseWelcomeImageControllerServiceGetApiWelcomeImagesTodayKeyFn(queryKey), queryFn: () => WelcomeImageControllerService.getApiWelcomeImagesToday() as TData, ...options });
/**
* @param data The data for the request.
* @param data.date
* @param data.timeOfDay
* @returns WelcomeImageResponse OK
* @throws ApiError
*/
export const useWelcomeImageControllerServiceGetApiWelcomeImagesImage = <TData = Common.WelcomeImageControllerServiceGetApiWelcomeImagesImageDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ date, timeOfDay }: {
  date: string;
  timeOfDay: "MORNING" | "AFTERNOON" | "EVENING";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseWelcomeImageControllerServiceGetApiWelcomeImagesImageKeyFn({ date, timeOfDay }, queryKey), queryFn: () => WelcomeImageControllerService.getApiWelcomeImagesImage({ date, timeOfDay }) as TData, ...options });
/**
* @returns string OK
* @throws ApiError
*/
export const useWelcomeImageControllerServiceGetApiWelcomeImagesGenerateNow = <TData = Common.WelcomeImageControllerServiceGetApiWelcomeImagesGenerateNowDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseWelcomeImageControllerServiceGetApiWelcomeImagesGenerateNowKeyFn(queryKey), queryFn: () => WelcomeImageControllerService.getApiWelcomeImagesGenerateNow() as TData, ...options });
/**
* @param data The data for the request.
* @param data.userId
* @returns UserAvatarDTO OK
* @throws ApiError
*/
export const useUserAvatarControllerServiceGetApiV1UserAvatarsByUserId = <TData = Common.UserAvatarControllerServiceGetApiV1UserAvatarsByUserIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ userId }: {
  userId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseUserAvatarControllerServiceGetApiV1UserAvatarsByUserIdKeyFn({ userId }, queryKey), queryFn: () => UserAvatarControllerService.getApiV1UserAvatarsByUserId({ userId }) as TData, ...options });
/**
* @returns AvatarOptionDTO OK
* @throws ApiError
*/
export const useUserAvatarControllerServiceGetApiV1UserAvatarsAvailable = <TData = Common.UserAvatarControllerServiceGetApiV1UserAvatarsAvailableDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseUserAvatarControllerServiceGetApiV1UserAvatarsAvailableKeyFn(queryKey), queryFn: () => UserAvatarControllerService.getApiV1UserAvatarsAvailable() as TData, ...options });
/**
* Get all leads assigned to a task
* Retrieves all leads that are currently assigned to the specified task. Returns a stream of Lead objects with complete lead details. The task must exist in the system.
* @param data The data for the request.
* @param data.taskId Unique identifier of the task
* @returns Lead Successfully retrieved leads for the task
* @throws ApiError
*/
export const useLeadTaskManagementServiceGetApiLeadTasksTaskByTaskIdLeads = <TData = Common.LeadTaskManagementServiceGetApiLeadTasksTaskByTaskIdLeadsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ taskId }: {
  taskId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadTaskManagementServiceGetApiLeadTasksTaskByTaskIdLeadsKeyFn({ taskId }, queryKey), queryFn: () => LeadTaskManagementService.getApiLeadTasksTaskByTaskIdLeads({ taskId }) as TData, ...options });
/**
* Get count of leads assigned to a task
* Returns the total number of leads currently assigned to the specified task. This is a lightweight endpoint that provides quick statistics without returning full lead details.
* @param data The data for the request.
* @param data.taskId Unique identifier of the task
* @returns number Successfully retrieved lead count for the task
* @throws ApiError
*/
export const useLeadTaskManagementServiceGetApiLeadTasksTaskByTaskIdLeadsCount = <TData = Common.LeadTaskManagementServiceGetApiLeadTasksTaskByTaskIdLeadsCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ taskId }: {
  taskId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadTaskManagementServiceGetApiLeadTasksTaskByTaskIdLeadsCountKeyFn({ taskId }, queryKey), queryFn: () => LeadTaskManagementService.getApiLeadTasksTaskByTaskIdLeadsCount({ taskId }) as TData, ...options });
/**
* Get all tasks assigned to a lead
* Retrieves all tasks that are currently assigned to the specified lead. Returns a stream of Task objects with complete task details. The lead must exist in the system.
* @param data The data for the request.
* @param data.leadId Unique identifier of the lead
* @returns Task Successfully retrieved tasks for the lead
* @throws ApiError
*/
export const useLeadTaskManagementServiceGetApiLeadTasksLeadByLeadIdTasks = <TData = Common.LeadTaskManagementServiceGetApiLeadTasksLeadByLeadIdTasksDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ leadId }: {
  leadId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadTaskManagementServiceGetApiLeadTasksLeadByLeadIdTasksKeyFn({ leadId }, queryKey), queryFn: () => LeadTaskManagementService.getApiLeadTasksLeadByLeadIdTasks({ leadId }) as TData, ...options });
/**
* Get count of tasks assigned to a lead
* Returns the total number of tasks currently assigned to the specified lead. This is a lightweight endpoint that provides quick statistics without returning full task details.
* @param data The data for the request.
* @param data.leadId Unique identifier of the lead
* @returns number Successfully retrieved task count for the lead
* @throws ApiError
*/
export const useLeadTaskManagementServiceGetApiLeadTasksLeadByLeadIdTasksCount = <TData = Common.LeadTaskManagementServiceGetApiLeadTasksLeadByLeadIdTasksCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ leadId }: {
  leadId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadTaskManagementServiceGetApiLeadTasksLeadByLeadIdTasksCountKeyFn({ leadId }, queryKey), queryFn: () => LeadTaskManagementService.getApiLeadTasksLeadByLeadIdTasksCount({ leadId }) as TData, ...options });
/**
* Check if a task is assigned to a lead
* Verifies whether a specific task is currently assigned to a specific lead. Returns a boolean value indicating the existence of the association. This is useful for validation and UI state management.
* @param data The data for the request.
* @param data.leadId Unique identifier of the lead
* @param data.taskId Unique identifier of the task
* @returns boolean Successfully checked association existence
* @throws ApiError
*/
export const useLeadTaskManagementServiceGetApiLeadTasksLeadByLeadIdTaskByTaskIdExists = <TData = Common.LeadTaskManagementServiceGetApiLeadTasksLeadByLeadIdTaskByTaskIdExistsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ leadId, taskId }: {
  leadId: number;
  taskId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadTaskManagementServiceGetApiLeadTasksLeadByLeadIdTaskByTaskIdExistsKeyFn({ leadId, taskId }, queryKey), queryFn: () => LeadTaskManagementService.getApiLeadTasksLeadByLeadIdTaskByTaskIdExists({ leadId, taskId }) as TData, ...options });
/**
* @param data The data for the request.
* @param data.importId
* @returns LeadImportProgressDTO OK
* @throws ApiError
*/
export const useLeadImportServiceGetApiLeadContactsImportStatusByImportId = <TData = Common.LeadImportServiceGetApiLeadContactsImportStatusByImportIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ importId }: {
  importId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadImportServiceGetApiLeadContactsImportStatusByImportIdKeyFn({ importId }, queryKey), queryFn: () => LeadImportService.getApiLeadContactsImportStatusByImportId({ importId }) as TData, ...options });
/**
* @param data The data for the request.
* @param data.importId
* @returns ServerSentEventLeadImportProgressDTO OK
* @throws ApiError
*/
export const useLeadImportServiceGetApiLeadContactsImportProgressByImportId = <TData = Common.LeadImportServiceGetApiLeadContactsImportProgressByImportIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ importId }: {
  importId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadImportServiceGetApiLeadContactsImportProgressByImportIdKeyFn({ importId }, queryKey), queryFn: () => LeadImportService.getApiLeadContactsImportProgressByImportId({ importId }) as TData, ...options });
/**
* Pobierz historię importów
* Zwraca paginowaną listę historii importów kontaktów
* @param data The data for the request.
* @param data.page
* @param data.size
* @returns unknown Historia importów została pomyślnie pobrana
* @throws ApiError
*/
export const useLeadImportServiceGetApiLeadContactsImportHistory = <TData = Common.LeadImportServiceGetApiLeadContactsImportHistoryDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ page, size }: {
  page?: number;
  size?: number;
} = {}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadImportServiceGetApiLeadContactsImportHistoryKeyFn({ page, size }, queryKey), queryFn: () => LeadImportService.getApiLeadContactsImportHistory({ page, size }) as TData, ...options });
/**
* Pobierz historię importu po ID
* Zwraca szczegóły historii importu o podanym identyfikatorze
* @param data The data for the request.
* @param data.importId Identyfikator importu
* @returns LeadImportHistoryDTO Historia importu została pomyślnie znaleziona
* @throws ApiError
*/
export const useLeadImportServiceGetApiLeadContactsImportHistoryByImportId = <TData = Common.LeadImportServiceGetApiLeadContactsImportHistoryByImportIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ importId }: {
  importId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadImportServiceGetApiLeadContactsImportHistoryByImportIdKeyFn({ importId }, queryKey), queryFn: () => LeadImportService.getApiLeadContactsImportHistoryByImportId({ importId }) as TData, ...options });
/**
* Pobierz historię importów użytkownika
* Zwraca listę historii importów dla określonego użytkownika
* @param data The data for the request.
* @param data.username Nazwa użytkownika
* @returns LeadImportHistoryDTO Historia importów użytkownika została pomyślnie pobrana
* @throws ApiError
*/
export const useLeadImportServiceGetApiLeadContactsImportHistoryUserByUsername = <TData = Common.LeadImportServiceGetApiLeadContactsImportHistoryUserByUsernameDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ username }: {
  username: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadImportServiceGetApiLeadContactsImportHistoryUserByUsernameKeyFn({ username }, queryKey), queryFn: () => LeadImportService.getApiLeadContactsImportHistoryUserByUsername({ username }) as TData, ...options });
/**
* Eksportuj leady z paginacją do Excel
* Eksportuje określoną stronę leadów do pliku Excel
* @param data The data for the request.
* @param data.page Numer strony (0-based)
* @param data.size Rozmiar strony
* @returns binary Eksport został pomyślnie wygenerowany
* @throws ApiError
*/
export const useLeadImportServiceGetApiLeadContactsExportLeadsPaginated = <TData = Common.LeadImportServiceGetApiLeadContactsExportLeadsPaginatedDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ page, size }: {
  page?: number;
  size?: number;
} = {}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadImportServiceGetApiLeadContactsExportLeadsPaginatedKeyFn({ page, size }, queryKey), queryFn: () => LeadImportService.getApiLeadContactsExportLeadsPaginated({ page, size }) as TData, ...options });
/**
* Eksportuj leady z zakresu dat do Excel
* Eksportuje leady z określonego zakresu dat do pliku Excel
* @param data The data for the request.
* @param data.fromDate Data początkowa (yyyy-MM-dd)
* @param data.toDate Data końcowa (yyyy-MM-dd)
* @returns binary Eksport został pomyślnie wygenerowany
* @throws ApiError
*/
export const useLeadImportServiceGetApiLeadContactsExportLeadsByDateRange = <TData = Common.LeadImportServiceGetApiLeadContactsExportLeadsByDateRangeDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ fromDate, toDate }: {
  fromDate: string;
  toDate: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadImportServiceGetApiLeadContactsExportLeadsByDateRangeKeyFn({ fromDate, toDate }, queryKey), queryFn: () => LeadImportService.getApiLeadContactsExportLeadsByDateRange({ fromDate, toDate }) as TData, ...options });
/**
* Eksportuj wszystkie leady do Excel
* Eksportuje wszystkie leady do pliku Excel
* @returns binary Eksport został pomyślnie wygenerowany
* @throws ApiError
*/
export const useLeadImportServiceGetApiLeadContactsExportAllLeads = <TData = Common.LeadImportServiceGetApiLeadContactsExportAllLeadsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadImportServiceGetApiLeadContactsExportAllLeadsKeyFn(queryKey), queryFn: () => LeadImportService.getApiLeadContactsExportAllLeads() as TData, ...options });
/**
* Pobierz szablon Excel do importu
* Zwraca plik Excel z szablonem do importu kontaktów
* @returns binary Szablon został pomyślnie wygenerowany
* @throws ApiError
*/
export const useLeadImportServiceGetApiLeadContactsExcelTemplate = <TData = Common.LeadImportServiceGetApiLeadContactsExcelTemplateDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadImportServiceGetApiLeadContactsExcelTemplateKeyFn(queryKey), queryFn: () => LeadImportService.getApiLeadContactsExcelTemplate() as TData, ...options });
/**
* Lista wszystkich plików w domenie
* Pobiera listę wszystkich plików w domenie zalogowanego użytkownika
* @returns unknown Lista plików została pomyślnie pobrana
* @throws ApiError
*/
export const useMinIoFileStorageServiceGetApiFiles = <TData = Common.MinIoFileStorageServiceGetApiFilesDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseMinIoFileStorageServiceGetApiFilesKeyFn(queryKey), queryFn: () => MinIoFileStorageService.getApiFiles() as TData, ...options });
/**
* Pobierz miniaturę obrazu
* Generuje i zwraca miniaturę obrazu dla pliku z domeny użytkownika
* @param data The data for the request.
* @param data.filename Nazwa pliku do utworzenia miniatury
* @param data.size Rozmiar miniatury (domyślnie 150px)
* @param data.quality Jakość kompresji JPEG (1-100, domyślnie 85)
* @returns DataBuffer Miniatura została wygenerowana i zwrócona
* @throws ApiError
*/
export const useMinIoFileStorageServiceGetApiFilesByFilenameThumbnail = <TData = Common.MinIoFileStorageServiceGetApiFilesByFilenameThumbnailDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ filename, quality, size }: {
  filename: string;
  quality?: number;
  size?: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseMinIoFileStorageServiceGetApiFilesByFilenameThumbnailKeyFn({ filename, quality, size }, queryKey), queryFn: () => MinIoFileStorageService.getApiFilesByFilenameThumbnail({ filename, quality, size }) as TData, ...options });
/**
* Pobierz plik
* Generuje URL do pobrania pliku z domeny użytkownika
* @param data The data for the request.
* @param data.filename Nazwa pliku do pobrania
* @returns string URL do pobrania został wygenerowany
* @throws ApiError
*/
export const useMinIoFileStorageServiceGetApiFilesByFilenameDownload = <TData = Common.MinIoFileStorageServiceGetApiFilesByFilenameDownloadDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ filename }: {
  filename: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseMinIoFileStorageServiceGetApiFilesByFilenameDownloadKeyFn({ filename }, queryKey), queryFn: () => MinIoFileStorageService.getApiFilesByFilenameDownload({ filename }) as TData, ...options });
/**
* Informacje o magazynie
* Pobiera informacje o wykorzystaniu magazynu w domenie użytkownika
* @returns unknown Informacje o magazynie zostały pomyślnie pobrane
* @throws ApiError
*/
export const useMinIoFileStorageServiceGetApiFilesStorageInfo = <TData = Common.MinIoFileStorageServiceGetApiFilesStorageInfoDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseMinIoFileStorageServiceGetApiFilesStorageInfoKeyFn(queryKey), queryFn: () => MinIoFileStorageService.getApiFilesStorageInfo() as TData, ...options });
/**
* Lista plików użytkownika
* Pobiera listę plików wgranych przez zalogowanego użytkownika w jego domenie
* @returns FileMetadataDTO Lista plików użytkownika została pomyślnie pobrana
* @throws ApiError
*/
export const useMinIoFileStorageServiceGetApiFilesMyFiles = <TData = Common.MinIoFileStorageServiceGetApiFilesMyFilesDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseMinIoFileStorageServiceGetApiFilesMyFilesKeyFn(queryKey), queryFn: () => MinIoFileStorageService.getApiFilesMyFiles() as TData, ...options });
/**
* Pliki przypisane do taska lub leada
* Pobiera pliki przypisane do taska lub leada
* @param data The data for the request.
* @param data.id
* @param data.type
* @returns FileMetadataDTO Pobiera pliki przypisane do taska lub leada
* @throws ApiError
*/
export const useMinIoFileStorageServiceGetApiFilesByRelatedObjectByIdByType = <TData = Common.MinIoFileStorageServiceGetApiFilesByRelatedObjectByIdByTypeDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ id, type }: {
  id: string;
  type: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseMinIoFileStorageServiceGetApiFilesByRelatedObjectByIdByTypeKeyFn({ id, type }, queryKey), queryFn: () => MinIoFileStorageService.getApiFilesByRelatedObjectByIdByType({ id, type }) as TData, ...options });
/**
* Get company logo
* Retrieves the company logo
* @returns CompanyLogo Logo retrieved successfully
* @throws ApiError
*/
export const useCompanyLogoServiceGetApiCompanyLogo = <TData = Common.CompanyLogoServiceGetApiCompanyLogoDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCompanyLogoServiceGetApiCompanyLogoKeyFn(queryKey), queryFn: () => CompanyLogoService.getApiCompanyLogo() as TData, ...options });
/**
* Check if email is already taken
* Checks if the provided email is already registered in the system.
* @param data The data for the request.
* @param data.email Email to check
* @returns EmailCheckResponseDTO Email check completed
* @throws ApiError
*/
export const useRegistrationServiceGetApiAuthRegisterCheckEmail = <TData = Common.RegistrationServiceGetApiAuthRegisterCheckEmailDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ email }: {
  email: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseRegistrationServiceGetApiAuthRegisterCheckEmailKeyFn({ email }, queryKey), queryFn: () => RegistrationService.getApiAuthRegisterCheckEmail({ email }) as TData, ...options });
/**
* Check if domain is already taken
* Checks if the provided domain name is already registered in the system.
* @param data The data for the request.
* @param data.domainName Domain name to check
* @returns DomainCheckResponseDTO Domain check completed
* @throws ApiError
*/
export const useRegistrationServiceGetApiAuthRegisterCheckDomain = <TData = Common.RegistrationServiceGetApiAuthRegisterCheckDomainDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ domainName }: {
  domainName: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseRegistrationServiceGetApiAuthRegisterCheckDomainKeyFn({ domainName }, queryKey), queryFn: () => RegistrationService.getApiAuthRegisterCheckDomain({ domainName }) as TData, ...options });
/**
* Zweryfikuj token resetu hasła
* Sprawdza, czy przekazany token resetu hasła jest poprawny i nie wygasł
* @param data The data for the request.
* @param data.token Token resetu hasła
* @returns unknown Token jest poprawny
* @throws ApiError
*/
export const usePasswordResetServiceGetApiAuthPasswordValidate = <TData = Common.PasswordResetServiceGetApiAuthPasswordValidateDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ token }: {
  token: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UsePasswordResetServiceGetApiAuthPasswordValidateKeyFn({ token }, queryKey), queryFn: () => PasswordResetService.getApiAuthPasswordValidate({ token }) as TData, ...options });
/**
* Pobiera wszystkie alerty w systemie
* Zwraca listę wszystkich alertów posortowanych po dacie utworzenia
* @returns AlertDTO OK
* @throws ApiError
*/
export const useAlertsServiceGetApiAlerts = <TData = Common.AlertsServiceGetApiAlertsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAlertsServiceGetApiAlertsKeyFn(queryKey), queryFn: () => AlertsService.getApiAlerts() as TData, ...options });
/**
* Pobiera wszystkie alerty użytkownika
* @param data The data for the request.
* @param data.userId
* @returns AlertDTO OK
* @throws ApiError
*/
export const useAlertsServiceGetApiAlertsUserByUserId = <TData = Common.AlertsServiceGetApiAlertsUserByUserIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ userId }: {
  userId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAlertsServiceGetApiAlertsUserByUserIdKeyFn({ userId }, queryKey), queryFn: () => AlertsService.getApiAlertsUserByUserId({ userId }) as TData, ...options });
/**
* Pobiera alerty użytkownika dla konkretnego taska
* @param data The data for the request.
* @param data.userId ID użytkownika
* @param data.taskId ID taska
* @returns AlertDTO OK
* @throws ApiError
*/
export const useAlertsServiceGetApiAlertsUserByUserIdTaskByTaskId = <TData = Common.AlertsServiceGetApiAlertsUserByUserIdTaskByTaskIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ taskId, userId }: {
  taskId: number;
  userId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAlertsServiceGetApiAlertsUserByUserIdTaskByTaskIdKeyFn({ taskId, userId }, queryKey), queryFn: () => AlertsService.getApiAlertsUserByUserIdTaskByTaskId({ taskId, userId }) as TData, ...options });
/**
* Pobiera alerty użytkownika według statusu
* @param data The data for the request.
* @param data.userId
* @param data.done
* @returns AlertDTO OK
* @throws ApiError
*/
export const useAlertsServiceGetApiAlertsUserByUserIdStatus = <TData = Common.AlertsServiceGetApiAlertsUserByUserIdStatusDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ done, userId }: {
  done: boolean;
  userId: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAlertsServiceGetApiAlertsUserByUserIdStatusKeyFn({ done, userId }, queryKey), queryFn: () => AlertsService.getApiAlertsUserByUserIdStatus({ done, userId }) as TData, ...options });
/**
* Pobiera wszystkie alerty dla konkretnego taska
* @param data The data for the request.
* @param data.taskId ID taska
* @returns AlertDTO OK
* @throws ApiError
*/
export const useAlertsServiceGetApiAlertsTaskByTaskId = <TData = Common.AlertsServiceGetApiAlertsTaskByTaskIdDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ taskId }: {
  taskId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAlertsServiceGetApiAlertsTaskByTaskIdKeyFn({ taskId }, queryKey), queryFn: () => AlertsService.getApiAlertsTaskByTaskId({ taskId }) as TData, ...options });
/**
* Pobiera alerty taska według statusu
* @param data The data for the request.
* @param data.taskId ID taska
* @param data.done Status zakończenia
* @returns AlertDTO OK
* @throws ApiError
*/
export const useAlertsServiceGetApiAlertsTaskByTaskIdStatus = <TData = Common.AlertsServiceGetApiAlertsTaskByTaskIdStatusDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ done, taskId }: {
  done: boolean;
  taskId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAlertsServiceGetApiAlertsTaskByTaskIdStatusKeyFn({ done, taskId }, queryKey), queryFn: () => AlertsService.getApiAlertsTaskByTaskIdStatus({ done, taskId }) as TData, ...options });
/**
* Pobiera alerty według statusu
* @param data The data for the request.
* @param data.done
* @returns AlertDTO OK
* @throws ApiError
*/
export const useAlertsServiceGetApiAlertsStatus = <TData = Common.AlertsServiceGetApiAlertsStatusDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ done }: {
  done: boolean;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAlertsServiceGetApiAlertsStatusKeyFn({ done }, queryKey), queryFn: () => AlertsService.getApiAlertsStatus({ done }) as TData, ...options });
/**
* Pobiera dostępne opcje przypomnienia
* Zwraca listę wszystkich dostępnych opcji przypomnienia z opisami
* @returns unknown Lista opcji przypomnienia
* @throws ApiError
*/
export const useAlertsServiceGetApiAlertsRemindOptions = <TData = Common.AlertsServiceGetApiAlertsRemindOptionsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseAlertsServiceGetApiAlertsRemindOptionsKeyFn(queryKey), queryFn: () => AlertsService.getApiAlertsRemindOptions() as TData, ...options });
/**
* Get company logo by filename
* Retrieves the company logo image from storage by filename. This endpoint is public and doesn't require authentication.
* @param data The data for the request.
* @param data.filename Logo filename
* @returns binary Logo retrieved successfully
* @throws ApiError
*/
export const useLogoServiceGetLogoByFilename = <TData = Common.LogoServiceGetLogoByFilenameDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ filename }: {
  filename: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLogoServiceGetLogoByFilenameKeyFn({ filename }, queryKey), queryFn: () => LogoService.getLogoByFilename({ filename }) as TData, ...options });
/**
* Wyszukiwanie w określonym typie obiektów
* Wyszukuje podaną frazę tylko w określonym typie obiektów:
* - **COMMENT**: tylko w komentarzach
* - **TASK**: tylko w zadaniach
* - **LEAD**: tylko w leadach (kontaktach)
* - **NOTE**: tylko w notatkach (plikach typu NOTE)
* - **FILE**: tylko w plikach (wszystkie pliki)
*
* Przydatne gdy użytkownik wie czego szuka i chce zawęzić wyniki.
*
* @param data The data for the request.
* @param data.searchTerm Fraza do wyszukania (minimum 2 znaki)
* @param data.type Typ obiektu do przeszukania
* @returns SearchResultDTO Wyniki wyszukiwania zwrócone pomyślnie
* @throws ApiError
*/
export const useGlobalSearchServiceGetApiSearchByType = <TData = Common.GlobalSearchServiceGetApiSearchByTypeDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ searchTerm, type }: {
  searchTerm: string;
  type: "LEAD" | "TASK" | "COMMENT" | "NOTE" | "FILE";
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseGlobalSearchServiceGetApiSearchByTypeKeyFn({ searchTerm, type }, queryKey), queryFn: () => GlobalSearchService.getApiSearchByType({ searchTerm, type }) as TData, ...options });
/**
* Globalne wyszukiwanie
* Wyszukuje podaną frazę w całej aplikacji CRM:
* - **Komentarze**: przeszukuje treść, autora i wzmiankowanych użytkowników
* - **Zadania**: przeszukuje tytuł, opis, status, typ, priorytet, użytkowników
* - **Leady (Kontakty)**: przeszukuje imię, nazwisko, email, telefon, miasto, NIP
* - **Notatki**: przeszukuje nazwy plików i użytkowników (tylko pliki typu NOTE)
* - **Pliki**: przeszukuje nazwy plików, typy zawartości, użytkowników (wszystkie pliki)
*
* Wyniki są sortowane według relevancji (najlepsze dopasowania na górze).
* Maksymalnie zwracanych jest 50 wyników dla wydajności.
*
* @param data The data for the request.
* @param data.searchTerm Fraza do wyszukania (minimum 2 znaki). Wyszukiwanie jest case-insensitive.
* @returns SearchResultDTO Wyniki wyszukiwania zwrócone pomyślnie
* @throws ApiError
*/
export const useGlobalSearchServiceGetApiSearch = <TData = Common.GlobalSearchServiceGetApiSearchDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ searchTerm }: {
  searchTerm: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseGlobalSearchServiceGetApiSearchKeyFn({ searchTerm }, queryKey), queryFn: () => GlobalSearchService.getApiSearch({ searchTerm }) as TData, ...options });
/**
* Raport czasu w statusach zadania
* Zwraca raport pokazujący ile dni zadanie spędziło w każdym statusie. Dynamika pracy nad zadaniem.
* @param data The data for the request.
* @param data.taskId
* @returns TaskStatusDurationReportDTO OK
* @throws ApiError
*/
export const useReportsServiceGetApiReportsTasksByTaskIdStatusDuration = <TData = Common.ReportsServiceGetApiReportsTasksByTaskIdStatusDurationDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ taskId }: {
  taskId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseReportsServiceGetApiReportsTasksByTaskIdStatusDurationKeyFn({ taskId }, queryKey), queryFn: () => ReportsService.getApiReportsTasksByTaskIdStatusDuration({ taskId }) as TData, ...options });
/**
* Podsumowanie statusów zadań
* Zwraca liczbę zadań w każdym ze statusów (TODO, IN_PROGRESS, CANCELED, DONE)
* @returns TaskStatusSummaryDTO OK
* @throws ApiError
*/
export const useReportsServiceGetApiReportsTasksStatusSummary = <TData = Common.ReportsServiceGetApiReportsTasksStatusSummaryDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseReportsServiceGetApiReportsTasksStatusSummaryKeyFn(queryKey), queryFn: () => ReportsService.getApiReportsTasksStatusSummary() as TData, ...options });
/**
* Raport liczby tasków
* Zwraca liczbę tasków utworzonych w różnych przedziałach czasowych: 7, 14 i 30 dni
* @returns TasksCountReportDTO OK
* @throws ApiError
*/
export const useReportsServiceGetApiReportsTasksLastDaysCount = <TData = Common.ReportsServiceGetApiReportsTasksLastDaysCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseReportsServiceGetApiReportsTasksLastDaysCountKeyFn(queryKey), queryFn: () => ReportsService.getApiReportsTasksLastDaysCount() as TData, ...options });
/**
* Raport liczby leadów
* Zwraca liczbę kontaktów Lead dodanych w różnych przedziałach czasowych: 7, 14, 30 i 60 dni
* @returns LeadsCountReportDTO OK
* @throws ApiError
*/
export const useReportsServiceGetApiReportsLeadsLastDaysCount = <TData = Common.ReportsServiceGetApiReportsLeadsLastDaysCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseReportsServiceGetApiReportsLeadsLastDaysCountKeyFn(queryKey), queryFn: () => ReportsService.getApiReportsLeadsLastDaysCount() as TData, ...options });
/**
* Get all leads assigned to a task
* Retrieves all leads that are currently assigned to the specified task. Returns a stream of Lead objects with complete lead details. The task must exist in the system.
* @param data The data for the request.
* @param data.taskId Unique identifier of the task
* @returns Lead Successfully retrieved leads for the task
* @throws ApiError
*/
export const useLeadRetrievalServiceGetApiLeadTasksTaskByTaskIdLeads = <TData = Common.LeadRetrievalServiceGetApiLeadTasksTaskByTaskIdLeadsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ taskId }: {
  taskId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadRetrievalServiceGetApiLeadTasksTaskByTaskIdLeadsKeyFn({ taskId }, queryKey), queryFn: () => LeadRetrievalService.getApiLeadTasksTaskByTaskIdLeads({ taskId }) as TData, ...options });
/**
* Get count of leads assigned to a task
* Returns the total number of leads currently assigned to the specified task. This is a lightweight endpoint that provides quick statistics without returning full lead details.
* @param data The data for the request.
* @param data.taskId Unique identifier of the task
* @returns number Successfully retrieved lead count for the task
* @throws ApiError
*/
export const useStatisticsServiceGetApiLeadTasksTaskByTaskIdLeadsCount = <TData = Common.StatisticsServiceGetApiLeadTasksTaskByTaskIdLeadsCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ taskId }: {
  taskId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseStatisticsServiceGetApiLeadTasksTaskByTaskIdLeadsCountKeyFn({ taskId }, queryKey), queryFn: () => StatisticsService.getApiLeadTasksTaskByTaskIdLeadsCount({ taskId }) as TData, ...options });
/**
* Get count of tasks assigned to a lead
* Returns the total number of tasks currently assigned to the specified lead. This is a lightweight endpoint that provides quick statistics without returning full task details.
* @param data The data for the request.
* @param data.leadId Unique identifier of the lead
* @returns number Successfully retrieved task count for the lead
* @throws ApiError
*/
export const useStatisticsServiceGetApiLeadTasksLeadByLeadIdTasksCount = <TData = Common.StatisticsServiceGetApiLeadTasksLeadByLeadIdTasksCountDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ leadId }: {
  leadId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseStatisticsServiceGetApiLeadTasksLeadByLeadIdTasksCountKeyFn({ leadId }, queryKey), queryFn: () => StatisticsService.getApiLeadTasksLeadByLeadIdTasksCount({ leadId }) as TData, ...options });
/**
* Get all tasks assigned to a lead
* Retrieves all tasks that are currently assigned to the specified lead. Returns a stream of Task objects with complete task details. The lead must exist in the system.
* @param data The data for the request.
* @param data.leadId Unique identifier of the lead
* @returns Task Successfully retrieved tasks for the lead
* @throws ApiError
*/
export const useTaskRetrievalServiceGetApiLeadTasksLeadByLeadIdTasks = <TData = Common.TaskRetrievalServiceGetApiLeadTasksLeadByLeadIdTasksDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ leadId }: {
  leadId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseTaskRetrievalServiceGetApiLeadTasksLeadByLeadIdTasksKeyFn({ leadId }, queryKey), queryFn: () => TaskRetrievalService.getApiLeadTasksLeadByLeadIdTasks({ leadId }) as TData, ...options });
/**
* Check if a task is assigned to a lead
* Verifies whether a specific task is currently assigned to a specific lead. Returns a boolean value indicating the existence of the association. This is useful for validation and UI state management.
* @param data The data for the request.
* @param data.leadId Unique identifier of the lead
* @param data.taskId Unique identifier of the task
* @returns boolean Successfully checked association existence
* @throws ApiError
*/
export const useValidationServiceGetApiLeadTasksLeadByLeadIdTaskByTaskIdExists = <TData = Common.ValidationServiceGetApiLeadTasksLeadByLeadIdTaskByTaskIdExistsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ leadId, taskId }: {
  leadId: number;
  taskId: number;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseValidationServiceGetApiLeadTasksLeadByLeadIdTaskByTaskIdExistsKeyFn({ leadId, taskId }, queryKey), queryFn: () => ValidationService.getApiLeadTasksLeadByLeadIdTaskByTaskIdExists({ leadId, taskId }) as TData, ...options });
/**
* Szybkie wyszukiwanie kontaktów
* Wyszukuje kontakty po firstName, lastName, city, phone, email. Wymaga minimum 3 znaków. Wyniki są cache'owane.
* @param data The data for the request.
* @param data.q Fraza do wyszukania (minimum 3 znaki)
* @returns LeadDTO Wyszukiwanie zakończone pomyślnie
* @throws ApiError
*/
export const useLeadSearchServiceGetApiLeadContactsSearch = <TData = Common.LeadSearchServiceGetApiLeadContactsSearchDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>({ q }: {
  q: string;
}, queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseLeadSearchServiceGetApiLeadContactsSearchKeyFn({ q }, queryKey), queryFn: () => LeadSearchService.getApiLeadContactsSearch({ q }) as TData, ...options });
/**
* @returns CarouselStats OK
* @throws ApiError
*/
export const useCarouselControllerServiceGetApiCarouselStats = <TData = Common.CarouselControllerServiceGetApiCarouselStatsDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCarouselControllerServiceGetApiCarouselStatsKeyFn(queryKey), queryFn: () => CarouselControllerService.getApiCarouselStats() as TData, ...options });
/**
* @returns DailyCarouselImageResponse OK
* @throws ApiError
*/
export const useCarouselControllerServiceGetApiCarouselDailyImage = <TData = Common.CarouselControllerServiceGetApiCarouselDailyImageDefaultResponse, TError = unknown, TQueryKey extends Array<unknown> = unknown[]>(queryKey?: TQueryKey, options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">) => useQuery<TData, TError>({ queryKey: Common.UseCarouselControllerServiceGetApiCarouselDailyImageKeyFn(queryKey), queryFn: () => CarouselControllerService.getApiCarouselDailyImage() as TData, ...options });
/**
* Utwórz nowego użytkownika
* Tworzy nowego użytkownika w systemie Keycloak
* @param data The data for the request.
* @param data.requestBody
* @returns string Użytkownik utworzony pomyślnie
* @throws ApiError
*/
export const useUserServicePostApiUser = <TData = Common.UserServicePostApiUserMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: UserDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: UserDTO;
}, TContext>({ mutationFn: ({ requestBody }) => UserService.postApiUser({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Promuj użytkownika do roli ADMIN
* Nadaje użytkownikowi rolę `api-admin` (oraz opcjonalnie usuwa `api-user`).
* @param data The data for the request.
* @param data.userId ID użytkownika
* @returns string Rola zmieniona pomyślnie
* @throws ApiError
*/
export const useUserServicePostApiUserByUserIdPromoteToAdmin = <TData = Common.UserServicePostApiUserByUserIdPromoteToAdminMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  userId: string;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  userId: string;
}, TContext>({ mutationFn: ({ userId }) => UserService.postApiUserByUserIdPromoteToAdmin({ userId }) as unknown as Promise<TData>, ...options });
/**
* Degraduj użytkownika z roli ADMIN
* Usuwa użytkownikowi rolę `api-admin` i nadaje rolę `api-user`.
* @param data The data for the request.
* @param data.userId ID użytkownika
* @returns string Rola zmieniona pomyślnie
* @throws ApiError
*/
export const useUserServicePostApiUserByUserIdDemoteFromAdmin = <TData = Common.UserServicePostApiUserByUserIdDemoteFromAdminMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  userId: string;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  userId: string;
}, TContext>({ mutationFn: ({ userId }) => UserService.postApiUserByUserIdDemoteFromAdmin({ userId }) as unknown as Promise<TData>, ...options });
/**
* Weryfikuje dostęp użytkownika do subdomeny
* Sprawdza czy użytkownik należy do grupy w Keycloak odpowiadającej subdomenie wyciągniętej z nagłówka Host requestu. Dla profili dev, dev-with-local-mail i local - requesty z localhost zawsze zwracają status 200.
* @param data The data for the request.
* @param data.username Login użytkownika
* @returns string Dostęp dozwolony
* @throws ApiError
*/
export const useUserServicePostApiUserVerifyDomainAccess = <TData = Common.UserServicePostApiUserVerifyDomainAccessMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  username: string;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  username: string;
}, TContext>({ mutationFn: ({ username }) => UserService.postApiUserVerifyDomainAccess({ username }) as unknown as Promise<TData>, ...options });
/**
* Wgraj avatar użytkownika
* Wgrywa avatar dla aktualnie zalogowanego użytkownika
* @param data The data for the request.
* @param data.formData
* @returns unknown Avatar został pomyślnie wgrany
* @throws ApiError
*/
export const useUserServicePostApiUserMeAvatar = <TData = Common.UserServicePostApiUserMeAvatarMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  formData?: { file: (Blob | File); };
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  formData?: { file: (Blob | File); };
}, TContext>({ mutationFn: ({ formData }) => UserService.postApiUserMeAvatar({ formData }) as unknown as Promise<TData>, ...options });
/**
* Utwórz nowe zadanie
* Tworzy nowe zadanie w systemie z danymi przekazanymi w żądaniu
* @param data The data for the request.
* @param data.requestBody Dane nowego zadania
* @returns TaskDTO Zadanie zostało pomyślnie utworzone
* @throws ApiError
*/
export const useTasksServicePostApiTasks = <TData = Common.TasksServicePostApiTasksMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: TaskDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: TaskDTO;
}, TContext>({ mutationFn: ({ requestBody }) => TasksService.postApiTasks({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Utwórz nowy predefiniowany atrybut
* Tworzy nowy predefiniowany atrybut dla leadów w domenie użytkownika
* @param data The data for the request.
* @param data.requestBody
* @returns PredefinedLeadAttributeDTO Predefiniowany atrybut został pomyślnie utworzony
* @throws ApiError
*/
export const useLeadAttributesServicePostApiPredefinedLeadAttributes = <TData = Common.LeadAttributesServicePostApiPredefinedLeadAttributesMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: PredefinedLeadAttributeDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: PredefinedLeadAttributeDTO;
}, TContext>({ mutationFn: ({ requestBody }) => LeadAttributesService.postApiPredefinedLeadAttributes({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Utwórz nową ofertę
* @param data The data for the request.
* @param data.requestBody
* @returns OfferDTO Created
* @throws ApiError
*/
export const useOffersServicePostApiOffers = <TData = Common.OffersServicePostApiOffersMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: OfferDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: OfferDTO;
}, TContext>({ mutationFn: ({ requestBody }) => OffersService.postApiOffers({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Utwórz nowy kontakt
* Tworzy nowy kontakt typu lead
* @param data The data for the request.
* @param data.requestBody
* @returns LeadDTO Kontakt został pomyślnie utworzony
* @throws ApiError
*/
export const useLeadCrudServicePostApiLeadContacts = <TData = Common.LeadCrudServicePostApiLeadContactsMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: LeadDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: LeadDTO;
}, TContext>({ mutationFn: ({ requestBody }) => LeadCrudService.postApiLeadContacts({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Utwórz nowy komentarz z obsługą wzmiankowania
* @param data The data for the request.
* @param data.requestBody
* @returns CommentDTO Created
* @throws ApiError
*/
export const useCommentsServicePostApiComments = <TData = Common.CommentsServicePostApiCommentsMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: CommentDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: CommentDTO;
}, TContext>({ mutationFn: ({ requestBody }) => CommentsService.postApiComments({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Utwórz wiele atrybutów jednocześnie
* @param data The data for the request.
* @param data.requestBody
* @returns AttributeDTO Created
* @throws ApiError
*/
export const useAttributesServicePostApiAttributesBulk = <TData = Common.AttributesServicePostApiAttributesBulkMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: AttributeDTO[];
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: AttributeDTO[];
}, TContext>({ mutationFn: ({ requestBody }) => AttributesService.postApiAttributesBulk({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Utwórz nowy atrybut
* @param data The data for the request.
* @param data.requestBody
* @returns AttributeDTO Created
* @throws ApiError
*/
export const useAttributesServicePostApiAttributes = <TData = Common.AttributesServicePostApiAttributesMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: AttributeDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: AttributeDTO;
}, TContext>({ mutationFn: ({ requestBody }) => AttributesService.postApiAttributes({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Utwórz nowy typ pozyskania
* @param data The data for the request.
* @param data.requestBody
* @returns AcquisitionTypeDTO Created
* @throws ApiError
*/
export const useAcquisitionTypesServicePostAcquisitionTypes = <TData = Common.AcquisitionTypesServicePostAcquisitionTypesMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: AcquisitionTypeDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: AcquisitionTypeDTO;
}, TContext>({ mutationFn: ({ requestBody }) => AcquisitionTypesService.postAcquisitionTypes({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* @param data The data for the request.
* @param data.date
* @returns string OK
* @throws ApiError
*/
export const useWelcomeImageControllerServicePostApiWelcomeImagesGenerate = <TData = Common.WelcomeImageControllerServicePostApiWelcomeImagesGenerateMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  date: string;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  date: string;
}, TContext>({ mutationFn: ({ date }) => WelcomeImageControllerService.postApiWelcomeImagesGenerate({ date }) as unknown as Promise<TData>, ...options });
/**
* @returns string OK
* @throws ApiError
*/
export const useWelcomeImageControllerServicePostApiWelcomeImagesGenerateToday = <TData = Common.WelcomeImageControllerServicePostApiWelcomeImagesGenerateTodayMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, void, TContext>, "mutationFn">) => useMutation<TData, TError, void, TContext>({ mutationFn: () => WelcomeImageControllerService.postApiWelcomeImagesGenerateToday() as unknown as Promise<TData>, ...options });
/**
* @param data The data for the request.
* @param data.requestBody
* @returns unknown OK
* @throws ApiError
*/
export const useUserAvatarControllerServicePostApiV1UserAvatarsSelect = <TData = Common.UserAvatarControllerServicePostApiV1UserAvatarsSelectMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: SelectAvatarRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: SelectAvatarRequest;
}, TContext>({ mutationFn: ({ requestBody }) => UserAvatarControllerService.postApiV1UserAvatarsSelect({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Assign multiple tasks to a lead
* Creates associations between a single lead and multiple tasks. This endpoint allows bulk assignment of tasks to a lead, preventing duplicate associations. All specified tasks and the lead must exist in the system.
* @param data The data for the request.
* @param data.requestBody Request containing lead ID and list of task IDs to assign
* @returns unknown Tasks successfully assigned to lead
* @throws ApiError
*/
export const useTaskAssignmentServicePostApiLeadTasksAssignTasksToLead = <TData = Common.TaskAssignmentServicePostApiLeadTasksAssignTasksToLeadMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: AssignTasksToLeadRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: AssignTasksToLeadRequest;
}, TContext>({ mutationFn: ({ requestBody }) => TaskAssignmentService.postApiLeadTasksAssignTasksToLead({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Assign multiple tasks to a lead
* Creates associations between a single lead and multiple tasks. This endpoint allows bulk assignment of tasks to a lead, preventing duplicate associations. All specified tasks and the lead must exist in the system.
* @param data The data for the request.
* @param data.requestBody Request containing lead ID and list of task IDs to assign
* @returns unknown Tasks successfully assigned to lead
* @throws ApiError
*/
export const useLeadTaskManagementServicePostApiLeadTasksAssignTasksToLead = <TData = Common.LeadTaskManagementServicePostApiLeadTasksAssignTasksToLeadMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: AssignTasksToLeadRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: AssignTasksToLeadRequest;
}, TContext>({ mutationFn: ({ requestBody }) => LeadTaskManagementService.postApiLeadTasksAssignTasksToLead({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Assign multiple leads to a task
* Creates associations between a single task and multiple leads. This endpoint allows bulk assignment of leads to a task, preventing duplicate associations. All specified leads and the task must exist in the system.
* @param data The data for the request.
* @param data.requestBody Request containing task ID and list of lead IDs to assign
* @returns unknown Leads successfully assigned to task
* @throws ApiError
*/
export const useLeadTaskManagementServicePostApiLeadTasksAssignLeadsToTask = <TData = Common.LeadTaskManagementServicePostApiLeadTasksAssignLeadsToTaskMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: AssignLeadsToTaskRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: AssignLeadsToTaskRequest;
}, TContext>({ mutationFn: ({ requestBody }) => LeadTaskManagementService.postApiLeadTasksAssignLeadsToTask({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Assign multiple leads to a task
* Creates associations between a single task and multiple leads. This endpoint allows bulk assignment of leads to a task, preventing duplicate associations. All specified leads and the task must exist in the system.
* @param data The data for the request.
* @param data.requestBody Request containing task ID and list of lead IDs to assign
* @returns unknown Leads successfully assigned to task
* @throws ApiError
*/
export const useLeadAssignmentServicePostApiLeadTasksAssignLeadsToTask = <TData = Common.LeadAssignmentServicePostApiLeadTasksAssignLeadsToTaskMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: AssignLeadsToTaskRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: AssignLeadsToTaskRequest;
}, TContext>({ mutationFn: ({ requestBody }) => LeadAssignmentService.postApiLeadTasksAssignLeadsToTask({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Importuj kontakty z pliku Excel z śledzeniem postępu
* Rozpoczyna import kontaktów z pliku Excel i zwraca ID sesji do śledzenia postępu
* @param data The data for the request.
* @param data.formData
* @returns string Import został rozpoczęty
* @throws ApiError
*/
export const useLeadImportServicePostApiLeadContactsImportExcelWithProgress = <TData = Common.LeadImportServicePostApiLeadContactsImportExcelWithProgressMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  formData?: { file: (Blob | File); };
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  formData?: { file: (Blob | File); };
}, TContext>({ mutationFn: ({ formData }) => LeadImportService.postApiLeadContactsImportExcelWithProgress({ formData }) as unknown as Promise<TData>, ...options });
/**
* Importuj kontakty z pliku Excel
* Importuje kontakty z pliku Excel, sprawdza duplikaty i zwraca raport importu
* @param data The data for the request.
* @param data.formData
* @returns LeadImportReportDTO Import został pomyślnie wykonany
* @throws ApiError
*/
export const useLeadImportServicePostApiLeadContactsImportExcel = <TData = Common.LeadImportServicePostApiLeadContactsImportExcelMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  formData?: { file: (Blob | File); };
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  formData?: { file: (Blob | File); };
}, TContext>({ mutationFn: ({ formData }) => LeadImportService.postApiLeadContactsImportExcel({ formData }) as unknown as Promise<TData>, ...options });
/**
* Eksportuj przefiltrowane leady do Excel
* Eksportuje leady spełniające kryteria filtrowania do pliku Excel
* @param data The data for the request.
* @param data.requestBody
* @returns binary Eksport został pomyślnie wygenerowany
* @throws ApiError
*/
export const useLeadImportServicePostApiLeadContactsExportFilteredLeads = <TData = Common.LeadImportServicePostApiLeadContactsExportFilteredLeadsMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: LeadFilterRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: LeadFilterRequest;
}, TContext>({ mutationFn: ({ requestBody }) => LeadImportService.postApiLeadContactsExportFilteredLeads({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Submit contact form
* Submit a contact form from website visitors. This endpoint is unsecured and does not require authentication.
* @param data The data for the request.
* @param data.requestBody
* @returns string Contact form submitted successfully
* @throws ApiError
*/
export const useCustomerContactServicePostApiHelpContact = <TData = Common.CustomerContactServicePostApiHelpContactMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: CustomerContactFormDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: CustomerContactFormDTO;
}, TContext>({ mutationFn: ({ requestBody }) => CustomerContactService.postApiHelpContact({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Wgraj plik
* Wgrywa plik do magazynu w domenie zalogowanego użytkownika
* @param data The data for the request.
* @param data.relatedObjectId ID obiektu powiązanego z plikiem (task, lead, notatka itp.)
* @param data.relatedObjectType Typ obiektu powiązanego z plikiem (TASK, LEAD, NOTE, COMMENT)
* @param data.formData
* @returns unknown Plik został pomyślnie wgrany
* @throws ApiError
*/
export const useMinIoFileStorageServicePostApiFilesUpload = <TData = Common.MinIoFileStorageServicePostApiFilesUploadMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  formData?: { file: (Blob | File); };
  relatedObjectId?: string;
  relatedObjectType?: "LEAD" | "TASK" | "COMMENT" | "NOTE";
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  formData?: { file: (Blob | File); };
  relatedObjectId?: string;
  relatedObjectType?: "LEAD" | "TASK" | "COMMENT" | "NOTE";
}, TContext>({ mutationFn: ({ formData, relatedObjectId, relatedObjectType }) => MinIoFileStorageService.postApiFilesUpload({ formData, relatedObjectId, relatedObjectType }) as unknown as Promise<TData>, ...options });
/**
* Upload company logo
* Uploads a logo for the company
* @param data The data for the request.
* @param data.formData
* @returns unknown Logo uploaded successfully
* @throws ApiError
*/
export const useCompanyLogoServicePostApiCompanyLogo = <TData = Common.CompanyLogoServicePostApiCompanyLogoMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  formData?: { file: (Blob | File); };
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  formData?: { file: (Blob | File); };
}, TContext>({ mutationFn: ({ formData }) => CompanyLogoService.postApiCompanyLogo({ formData }) as unknown as Promise<TData>, ...options });
/**
* Complete user registration
* Completes the user registration process using the provided confirmation token.
* @param data The data for the request.
* @param data.token Confirmation token received via email
* @param data.requestBody
* @returns RegistrationCompletionResponseDTO Registration completed successfully
* @throws ApiError
*/
export const useRegistrationServicePostApiAuthRegisterConfirm = <TData = Common.RegistrationServicePostApiAuthRegisterConfirmMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: RegistrationCompleteDTO;
  token: string;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: RegistrationCompleteDTO;
  token: string;
}, TContext>({ mutationFn: ({ requestBody, token }) => RegistrationService.postApiAuthRegisterConfirm({ requestBody, token }) as unknown as Promise<TData>, ...options });
/**
* Register a new domain and user account
* Registers a new domain based on the provided name and creates an initial user account associated with the provided email, after reCAPTCHA v3 validation.
* @param data The data for the request.
* @param data.requestBody
* @returns RegistrationResponseDTO Registration successful
* @throws ApiError
*/
export const useRegistrationServicePostApiAuthRegister = <TData = Common.RegistrationServicePostApiAuthRegisterMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: RegistrationRequestDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: RegistrationRequestDTO;
}, TContext>({ mutationFn: ({ requestBody }) => RegistrationService.postApiAuthRegister({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Resetuj hasło
* Ustawia nowe hasło dla konta, korzystając z poprawnego tokenu
* @param data The data for the request.
* @param data.requestBody
* @returns unknown Hasło zostało zaktualizowane
* @throws ApiError
*/
export const usePasswordResetServicePostApiAuthPasswordReset = <TData = Common.PasswordResetServicePostApiAuthPasswordResetMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: ResetPasswordDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: ResetPasswordDTO;
}, TContext>({ mutationFn: ({ requestBody }) => PasswordResetService.postApiAuthPasswordReset({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Wyślij link resetujący hasło
* Wysyła e-mail z tokenem resetu hasła do użytkownika o podanym adresie
* @param data The data for the request.
* @param data.requestBody
* @returns unknown Link resetujący został wysłany
* @throws ApiError
*/
export const usePasswordResetServicePostApiAuthPasswordResetRequest = <TData = Common.PasswordResetServicePostApiAuthPasswordResetRequestMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: ResetRequestDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: ResetRequestDTO;
}, TContext>({ mutationFn: ({ requestBody }) => PasswordResetService.postApiAuthPasswordResetRequest({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Tworzy nowy alert dla taska
* Tworzy alert przypisany do konkretnego taska. Task ID jest wymagane.
*
* **Dostępne opcje przypomnienia (remindOption):**
* - `FIFTEEN_MINUTES` - 15 minut przed
* - `ONE_HOUR` - 1 godzina przed
* - `TWO_HOURS` - 2 godziny przed
* - `THREE_HOURS` - 3 godziny przed
* - `ONE_DAY` - 1 dzień przed
*
* **Przykład JSON:**
* ```json
* {
* "userId": "user123",
* "taskId": 1,
* "message": "Pamiętaj o spotkaniu!",
* "dueDate": "2024-12-25T10:00:00Z",
* "remindOption": "ONE_HOUR",
* "channel": "EMAIL"
* }
* ```
*
* @param data The data for the request.
* @param data.requestBody
* @returns AlertDTO OK
* @throws ApiError
*/
export const useAlertsServicePostApiAlerts = <TData = Common.AlertsServicePostApiAlertsMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: AlertDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: AlertDTO;
}, TContext>({ mutationFn: ({ requestBody }) => AlertsService.postApiAlerts({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Oznacza alert jako zakończony
* @param data The data for the request.
* @param data.id
* @returns unknown OK
* @throws ApiError
*/
export const useAlertsServicePostApiAlertsByIdComplete = <TData = Common.AlertsServicePostApiAlertsByIdCompleteMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
}, TContext>({ mutationFn: ({ id }) => AlertsService.postApiAlertsByIdComplete({ id }) as unknown as Promise<TData>, ...options });
/**
* Oznacza wszystkie alerty użytkownika jako zakończone
* Znajduje i oznacza wszystkie aktywne alerty należące do danego użytkownika jako zakończone.
* @param data The data for the request.
* @param data.userId ID użytkownika
* @returns unknown Liczba zaktualizowanych alertów
* @throws ApiError
*/
export const useAlertsServicePostApiAlertsUserByUserIdCompleteAll = <TData = Common.AlertsServicePostApiAlertsUserByUserIdCompleteAllMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  userId: string;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  userId: string;
}, TContext>({ mutationFn: ({ userId }) => AlertsService.postApiAlertsUserByUserIdCompleteAll({ userId }) as unknown as Promise<TData>, ...options });
/**
* Oznacza wszystkie przeterminowane alerty jako zakończone
* Uruchamia proces, który wyszukuje wszystkie aktywne alerty z przeszłą datą 'dueDate' i oznacza je jako zakończone.
* @returns unknown Liczba zaktualizowanych alertów
* @throws ApiError
*/
export const useAlertsServicePostApiAlertsOverdueComplete = <TData = Common.AlertsServicePostApiAlertsOverdueCompleteMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, void, TContext>, "mutationFn">) => useMutation<TData, TError, void, TContext>({ mutationFn: () => AlertsService.postApiAlertsOverdueComplete() as unknown as Promise<TData>, ...options });
/**
* @param data The data for the request.
* @param data.requestBody
* @param data.origin
* @param data.referer
* @returns string OK
* @throws ApiError
*/
export const useAnalyticsControllerServicePostAnalytics = <TData = Common.AnalyticsControllerServicePostAnalyticsMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  origin?: string;
  referer?: string;
  requestBody: UserEventRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  origin?: string;
  referer?: string;
  requestBody: UserEventRequest;
}, TContext>({ mutationFn: ({ origin, referer, requestBody }) => AnalyticsControllerService.postAnalytics({ origin, referer, requestBody }) as unknown as Promise<TData>, ...options });
/**
* Aktualizuj dane użytkownika (tylko dla administratora)
* Aktualizuje dane (email, imię, nazwisko, atrybuty) wskazanego użytkownika. Uwaga: Aktualizacja adresu email może być ograniczona przez konfigurację Keycloak.
* @param data The data for the request.
* @param data.userId ID użytkownika
* @param data.requestBody
* @returns string Dane użytkownika zaktualizowane pomyślnie
* @throws ApiError
*/
export const useUserServicePutApiUserByUserId = <TData = Common.UserServicePutApiUserByUserIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: UserUpdateDTO;
  userId: string;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: UserUpdateDTO;
  userId: string;
}, TContext>({ mutationFn: ({ requestBody, userId }) => UserService.putApiUserByUserId({ requestBody, userId }) as unknown as Promise<TData>, ...options });
/**
* Aktualizuj dane aktualnie zalogowanego użytkownika
* Aktualizuje dane (email, imię, nazwisko, atrybuty) aktualnie zalogowanego użytkownika. Uwaga: Aktualizacja adresu email może być ograniczona przez konfigurację Keycloak.
* @param data The data for the request.
* @param data.requestBody
* @returns string Dane użytkownika zaktualizowane pomyślnie
* @throws ApiError
*/
export const useUserServicePutApiUserMe = <TData = Common.UserServicePutApiUserMeMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: UserUpdateDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: UserUpdateDTO;
}, TContext>({ mutationFn: ({ requestBody }) => UserService.putApiUserMe({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Aktualizuj zadanie
* Aktualizuje istniejące zadanie nowymi danymi
* @param data The data for the request.
* @param data.id Identyfikator zadania do aktualizacji
* @param data.requestBody Zaktualizowane dane zadania
* @returns TaskDTO Zadanie zostało pomyślnie zaktualizowane
* @throws ApiError
*/
export const useTasksServicePutApiTasksById = <TData = Common.TasksServicePutApiTasksByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
  requestBody: TaskDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
  requestBody: TaskDTO;
}, TContext>({ mutationFn: ({ id, requestBody }) => TasksService.putApiTasksById({ id, requestBody }) as unknown as Promise<TData>, ...options });
/**
* Usuń przypisanie zadania (ADMIN)
* Usuwa przypisanie zadania od użytkownika
* @param data The data for the request.
* @param data.id Identyfikator zadania
* @returns TaskDTO Przypisanie zadania zostało pomyślnie usunięte
* @throws ApiError
*/
export const useTasksServicePutApiTasksByIdUnassign = <TData = Common.TasksServicePutApiTasksByIdUnassignMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
}, TContext>({ mutationFn: ({ id }) => TasksService.putApiTasksByIdUnassign({ id }) as unknown as Promise<TData>, ...options });
/**
* Aktualizuj priorytet zadania
* Aktualizuje priorytet konkretnego zadania
* @param data The data for the request.
* @param data.id Identyfikator zadania
* @param data.priority Nowy priorytet zadania
* @returns TaskDTO Priorytet zadania został pomyślnie zaktualizowany
* @throws ApiError
*/
export const useTasksServicePutApiTasksByIdPriorityByPriority = <TData = Common.TasksServicePutApiTasksByIdPriorityByPriorityMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
  priority: "A" | "B" | "C" | "D" | "E";
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
  priority: "A" | "B" | "C" | "D" | "E";
}, TContext>({ mutationFn: ({ id, priority }) => TasksService.putApiTasksByIdPriorityByPriority({ id, priority }) as unknown as Promise<TData>, ...options });
/**
* Przypisz zadanie do użytkownika (ADMIN)
* Przypisuje zadanie do określonego użytkownika na podstawie jego Keycloak ID
* @param data The data for the request.
* @param data.id Identyfikator zadania
* @param data.keycloakUserId Identyfikator użytkownika w Keycloak
* @returns TaskDTO Zadanie zostało pomyślnie przypisane do użytkownika
* @throws ApiError
*/
export const useTasksServicePutApiTasksByIdAssignByKeycloakUserId = <TData = Common.TasksServicePutApiTasksByIdAssignByKeycloakUserIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
  keycloakUserId: string;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
  keycloakUserId: string;
}, TContext>({ mutationFn: ({ id, keycloakUserId }) => TasksService.putApiTasksByIdAssignByKeycloakUserId({ id, keycloakUserId }) as unknown as Promise<TData>, ...options });
/**
* Aktualizuj predefiniowany atrybut
* Aktualizuje istniejący predefiniowany atrybut w domenie użytkownika
* @param data The data for the request.
* @param data.id Identyfikator predefiniowanego atrybutu
* @param data.requestBody
* @returns PredefinedLeadAttributeDTO Predefiniowany atrybut został pomyślnie zaktualizowany
* @throws ApiError
*/
export const useLeadAttributesServicePutApiPredefinedLeadAttributesById = <TData = Common.LeadAttributesServicePutApiPredefinedLeadAttributesByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
  requestBody: PredefinedLeadAttributeDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
  requestBody: PredefinedLeadAttributeDTO;
}, TContext>({ mutationFn: ({ id, requestBody }) => LeadAttributesService.putApiPredefinedLeadAttributesById({ id, requestBody }) as unknown as Promise<TData>, ...options });
/**
* Aktualizuj ofertę
* @param data The data for the request.
* @param data.id
* @param data.requestBody
* @returns OfferDTO OK
* @throws ApiError
*/
export const useOffersServicePutApiOffersById = <TData = Common.OffersServicePutApiOffersByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
  requestBody: OfferDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
  requestBody: OfferDTO;
}, TContext>({ mutationFn: ({ id, requestBody }) => OffersService.putApiOffersById({ id, requestBody }) as unknown as Promise<TData>, ...options });
/**
* Aktualizuj kontakt
* Aktualizuje istniejący kontakt
* @param data The data for the request.
* @param data.id Identyfikator kontaktu
* @param data.requestBody
* @returns LeadDTO Kontakt został pomyślnie zaktualizowany
* @throws ApiError
*/
export const useLeadCrudServicePutApiLeadContactsById = <TData = Common.LeadCrudServicePutApiLeadContactsByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
  requestBody: LeadDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
  requestBody: LeadDTO;
}, TContext>({ mutationFn: ({ id, requestBody }) => LeadCrudService.putApiLeadContactsById({ id, requestBody }) as unknown as Promise<TData>, ...options });
/**
* Zmień status zadania
* Zmienia status zadania bez pozycjonowania
* @param data The data for the request.
* @param data.taskId Identyfikator zadania
* @param data.requestBody Nowy status zadania
* @returns unknown Status zadania został pomyślnie zaktualizowany
* @throws ApiError
*/
export const useKanbanServicePutApiKanbanTasksByTaskIdStatus = <TData = Common.KanbanServicePutApiKanbanTasksByTaskIdStatusMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: KanbanStatusUpdateRequest;
  taskId: number;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: KanbanStatusUpdateRequest;
  taskId: number;
}, TContext>({ mutationFn: ({ requestBody, taskId }) => KanbanService.putApiKanbanTasksByTaskIdStatus({ requestBody, taskId }) as unknown as Promise<TData>, ...options });
/**
* Aktualizuj wartość prefiksu
* Aktualizuje wartość prefiksu dla danego typu
* @param data The data for the request.
* @param data.prefixType
* @param data.requestBody
* @returns PrefixConfiguration Wartość prefiksu została pomyślnie zaktualizowana
* @throws ApiError
*/
export const usePrefixConfigControllerServicePutApiConfigPrefixByPrefixType = <TData = Common.PrefixConfigControllerServicePutApiConfigPrefixByPrefixTypeMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  prefixType: string;
  requestBody: UpdatePrefixValueRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  prefixType: string;
  requestBody: UpdatePrefixValueRequest;
}, TContext>({ mutationFn: ({ prefixType, requestBody }) => PrefixConfigControllerService.putApiConfigPrefixByPrefixType({ prefixType, requestBody }) as unknown as Promise<TData>, ...options });
/**
* Zaktualizuj istniejący komentarz
* @param data The data for the request.
* @param data.id
* @param data.requestBody
* @returns CommentDTO OK
* @throws ApiError
*/
export const useCommentsServicePutApiCommentsById = <TData = Common.CommentsServicePutApiCommentsByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
  requestBody: CommentDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
  requestBody: CommentDTO;
}, TContext>({ mutationFn: ({ id, requestBody }) => CommentsService.putApiCommentsById({ id, requestBody }) as unknown as Promise<TData>, ...options });
/**
* Zaktualizuj istniejący atrybut
* @param data The data for the request.
* @param data.id
* @param data.requestBody
* @returns AttributeDTO OK
* @throws ApiError
*/
export const useAttributesServicePutApiAttributesById = <TData = Common.AttributesServicePutApiAttributesByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
  requestBody: AttributeDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
  requestBody: AttributeDTO;
}, TContext>({ mutationFn: ({ id, requestBody }) => AttributesService.putApiAttributesById({ id, requestBody }) as unknown as Promise<TData>, ...options });
/**
* Zaktualizuj wiele atrybutów jednocześnie
* @param data The data for the request.
* @param data.requestBody
* @returns AttributeDTO OK
* @throws ApiError
*/
export const useAttributesServicePutApiAttributesBulk = <TData = Common.AttributesServicePutApiAttributesBulkMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: AttributeDTO[];
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: AttributeDTO[];
}, TContext>({ mutationFn: ({ requestBody }) => AttributesService.putApiAttributesBulk({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Aktualizuj typ pozyskania
* @param data The data for the request.
* @param data.id
* @param data.requestBody
* @returns AcquisitionTypeDTO OK
* @throws ApiError
*/
export const useAcquisitionTypesServicePutAcquisitionTypesById = <TData = Common.AcquisitionTypesServicePutAcquisitionTypesByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
  requestBody: AcquisitionTypeDTO;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
  requestBody: AcquisitionTypeDTO;
}, TContext>({ mutationFn: ({ id, requestBody }) => AcquisitionTypesService.putAcquisitionTypesById({ id, requestBody }) as unknown as Promise<TData>, ...options });
/**
* Zmień status pliku
* Zmienia status pliku w domenie zalogowanego użytkownika
* @param data The data for the request.
* @param data.filename Nazwa pliku do zmiany statusu
* @param data.status Nowy status pliku (ACTIVE lub DETACHED)
* @returns string Status pliku został pomyślnie zmieniony
* @throws ApiError
*/
export const useMinIoFileStorageServicePatchApiFilesByFilenameStatus = <TData = Common.MinIoFileStorageServicePatchApiFilesByFilenameStatusMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  filename: string;
  status: "ACTIVE" | "DETACHED";
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  filename: string;
  status: "ACTIVE" | "DETACHED";
}, TContext>({ mutationFn: ({ filename, status }) => MinIoFileStorageService.patchApiFilesByFilenameStatus({ filename, status }) as unknown as Promise<TData>, ...options });
/**
* Zmień status wielu plików
* Zmienia status wielu plików naraz w domenie zalogowanego użytkownika
* @param data The data for the request.
* @param data.status Nowy status plików (ACTIVE lub DETACHED)
* @param data.requestBody
* @returns unknown Status plików został pomyślnie zmieniony
* @throws ApiError
*/
export const useMinIoFileStorageServicePatchApiFilesBulkStatus = <TData = Common.MinIoFileStorageServicePatchApiFilesBulkStatusMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: string[];
  status: "ACTIVE" | "DETACHED";
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: string[];
  status: "ACTIVE" | "DETACHED";
}, TContext>({ mutationFn: ({ requestBody, status }) => MinIoFileStorageService.patchApiFilesBulkStatus({ requestBody, status }) as unknown as Promise<TData>, ...options });
/**
* Usuń użytkownika (tylko dla administratora)
* Usuwa wskazanego użytkownika z systemu. Jeśli użytkownik ma rolę api-admin, usuwa całą grupę wraz z wszystkimi członkami. Wszyscy użytkownicy otrzymają email potwierdzający usunięcie konta.
* @param data The data for the request.
* @param data.userId ID użytkownika do usunięcia
* @returns string Użytkownik został pomyślnie usunięty
* @throws ApiError
*/
export const useUserServiceDeleteApiUserByUserId = <TData = Common.UserServiceDeleteApiUserByUserIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  userId: string;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  userId: string;
}, TContext>({ mutationFn: ({ userId }) => UserService.deleteApiUserByUserId({ userId }) as unknown as Promise<TData>, ...options });
/**
* Usuń własne konto
* Usuwa konto aktualnie zalogowanego użytkownika. Po usunięciu konta nastąpi automatyczne wylogowanie. Jeśli użytkownik ma rolę api-admin, zostanie usunięta cała grupa wraz z wszystkimi członkami. Otrzymasz email potwierdzający usunięcie konta.
* @returns string Konto zostało pomyślnie usunięte
* @throws ApiError
*/
export const useUserServiceDeleteApiUserMe = <TData = Common.UserServiceDeleteApiUserMeMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, void, TContext>, "mutationFn">) => useMutation<TData, TError, void, TContext>({ mutationFn: () => UserService.deleteApiUserMe() as unknown as Promise<TData>, ...options });
/**
* Usuń zadanie
* Usuwa zadanie z systemu na podstawie jego identyfikatora
* @param data The data for the request.
* @param data.id Identyfikator zadania do usunięcia
* @returns void Zadanie zostało pomyślnie usunięte
* @throws ApiError
*/
export const useTasksServiceDeleteApiTasksById = <TData = Common.TasksServiceDeleteApiTasksByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
}, TContext>({ mutationFn: ({ id }) => TasksService.deleteApiTasksById({ id }) as unknown as Promise<TData>, ...options });
/**
* Usuń predefiniowany atrybut
* Usuwa predefiniowany atrybut o podanym identyfikatorze w domenie użytkownika
* @param data The data for the request.
* @param data.id Identyfikator predefiniowanego atrybutu
* @returns void Predefiniowany atrybut został pomyślnie usunięty
* @throws ApiError
*/
export const useLeadAttributesServiceDeleteApiPredefinedLeadAttributesById = <TData = Common.LeadAttributesServiceDeleteApiPredefinedLeadAttributesByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
}, TContext>({ mutationFn: ({ id }) => LeadAttributesService.deleteApiPredefinedLeadAttributesById({ id }) as unknown as Promise<TData>, ...options });
/**
* Usuń ofertę
* @param data The data for the request.
* @param data.id
* @returns void No Content
* @throws ApiError
*/
export const useOffersServiceDeleteApiOffersById = <TData = Common.OffersServiceDeleteApiOffersByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
}, TContext>({ mutationFn: ({ id }) => OffersService.deleteApiOffersById({ id }) as unknown as Promise<TData>, ...options });
/**
* Usuń kontakt
* Usuwa kontakt o podanym identyfikatorze
* @param data The data for the request.
* @param data.id Identyfikator kontaktu
* @returns void Kontakt został pomyślnie usunięty
* @throws ApiError
*/
export const useLeadCrudServiceDeleteApiLeadContactsById = <TData = Common.LeadCrudServiceDeleteApiLeadContactsByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
}, TContext>({ mutationFn: ({ id }) => LeadCrudService.deleteApiLeadContactsById({ id }) as unknown as Promise<TData>, ...options });
/**
* Usuń komentarz
* @param data The data for the request.
* @param data.id
* @returns void No Content
* @throws ApiError
*/
export const useCommentsServiceDeleteApiCommentsById = <TData = Common.CommentsServiceDeleteApiCommentsByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
}, TContext>({ mutationFn: ({ id }) => CommentsService.deleteApiCommentsById({ id }) as unknown as Promise<TData>, ...options });
/**
* Usuń atrybut
* @param data The data for the request.
* @param data.id
* @returns void No Content
* @throws ApiError
*/
export const useAttributesServiceDeleteApiAttributesById = <TData = Common.AttributesServiceDeleteApiAttributesByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
}, TContext>({ mutationFn: ({ id }) => AttributesService.deleteApiAttributesById({ id }) as unknown as Promise<TData>, ...options });
/**
* Usuń wszystkie atrybuty dla określonego obiektu
* @param data The data for the request.
* @param data.objectType
* @param data.objectId
* @returns void No Content
* @throws ApiError
*/
export const useAttributesServiceDeleteApiAttributesObjectByObjectTypeByObjectId = <TData = Common.AttributesServiceDeleteApiAttributesObjectByObjectTypeByObjectIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  objectId: number;
  objectType: "OFFER" | "LEAD" | "TASK";
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  objectId: number;
  objectType: "OFFER" | "LEAD" | "TASK";
}, TContext>({ mutationFn: ({ objectId, objectType }) => AttributesService.deleteApiAttributesObjectByObjectTypeByObjectId({ objectId, objectType }) as unknown as Promise<TData>, ...options });
/**
* Usuń typ pozyskania
* @param data The data for the request.
* @param data.id
* @returns void No Content
* @throws ApiError
*/
export const useAcquisitionTypesServiceDeleteAcquisitionTypesById = <TData = Common.AcquisitionTypesServiceDeleteAcquisitionTypesByIdMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  id: number;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  id: number;
}, TContext>({ mutationFn: ({ id }) => AcquisitionTypesService.deleteAcquisitionTypesById({ id }) as unknown as Promise<TData>, ...options });
/**
* Detach multiple tasks from a lead
* Removes associations between a single lead and multiple tasks. This endpoint allows bulk removal of tasks from a lead. Only existing associations will be removed - non-existent associations are ignored. All specified tasks and the lead must exist in the system.
* @param data The data for the request.
* @param data.requestBody Request containing lead ID and list of task IDs to detach
* @returns unknown Tasks successfully detached from lead
* @throws ApiError
*/
export const useLeadTaskManagementServiceDeleteApiLeadTasksDetachTasksFromLead = <TData = Common.LeadTaskManagementServiceDeleteApiLeadTasksDetachTasksFromLeadMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: DetachTasksFromLeadRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: DetachTasksFromLeadRequest;
}, TContext>({ mutationFn: ({ requestBody }) => LeadTaskManagementService.deleteApiLeadTasksDetachTasksFromLead({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Detach multiple leads from a task
* Removes associations between a single task and multiple leads. This endpoint allows bulk removal of leads from a task. Only existing associations will be removed - non-existent associations are ignored. All specified leads and the task must exist in the system.
* @param data The data for the request.
* @param data.requestBody Request containing task ID and list of lead IDs to detach
* @returns unknown Leads successfully detached from task
* @throws ApiError
*/
export const useLeadTaskManagementServiceDeleteApiLeadTasksDetachLeadsFromTask = <TData = Common.LeadTaskManagementServiceDeleteApiLeadTasksDetachLeadsFromTaskMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: DetachLeadsFromTaskRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: DetachLeadsFromTaskRequest;
}, TContext>({ mutationFn: ({ requestBody }) => LeadTaskManagementService.deleteApiLeadTasksDetachLeadsFromTask({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Usuń plik
* Usuwa plik z domeny zalogowanego użytkownika
* @param data The data for the request.
* @param data.filename Nazwa pliku do usunięcia
* @returns void Plik został usunięty
* @throws ApiError
*/
export const useMinIoFileStorageServiceDeleteApiFilesByFilename = <TData = Common.MinIoFileStorageServiceDeleteApiFilesByFilenameMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  filename: string;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  filename: string;
}, TContext>({ mutationFn: ({ filename }) => MinIoFileStorageService.deleteApiFilesByFilename({ filename }) as unknown as Promise<TData>, ...options });
/**
* Usuń wiele plików
* Usuwa wiele plików naraz z domeny zalogowanego użytkownika
* @param data The data for the request.
* @param data.requestBody
* @returns void Pliki zostały usunięte
* @throws ApiError
*/
export const useMinIoFileStorageServiceDeleteApiFilesBulk = <TData = Common.MinIoFileStorageServiceDeleteApiFilesBulkMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: string[];
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: string[];
}, TContext>({ mutationFn: ({ requestBody }) => MinIoFileStorageService.deleteApiFilesBulk({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Delete company logo
* Deletes the company logo
* @returns unknown Logo deleted successfully
* @throws ApiError
*/
export const useCompanyLogoServiceDeleteApiCompanyLogo = <TData = Common.CompanyLogoServiceDeleteApiCompanyLogoMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, void, TContext>, "mutationFn">) => useMutation<TData, TError, void, TContext>({ mutationFn: () => CompanyLogoService.deleteApiCompanyLogo() as unknown as Promise<TData>, ...options });
/**
* Detach multiple tasks from a lead
* Removes associations between a single lead and multiple tasks. This endpoint allows bulk removal of tasks from a lead. Only existing associations will be removed - non-existent associations are ignored. All specified tasks and the lead must exist in the system.
* @param data The data for the request.
* @param data.requestBody Request containing lead ID and list of task IDs to detach
* @returns unknown Tasks successfully detached from lead
* @throws ApiError
*/
export const useTaskRemovalServiceDeleteApiLeadTasksDetachTasksFromLead = <TData = Common.TaskRemovalServiceDeleteApiLeadTasksDetachTasksFromLeadMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: DetachTasksFromLeadRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: DetachTasksFromLeadRequest;
}, TContext>({ mutationFn: ({ requestBody }) => TaskRemovalService.deleteApiLeadTasksDetachTasksFromLead({ requestBody }) as unknown as Promise<TData>, ...options });
/**
* Detach multiple leads from a task
* Removes associations between a single task and multiple leads. This endpoint allows bulk removal of leads from a task. Only existing associations will be removed - non-existent associations are ignored. All specified leads and the task must exist in the system.
* @param data The data for the request.
* @param data.requestBody Request containing task ID and list of lead IDs to detach
* @returns unknown Leads successfully detached from task
* @throws ApiError
*/
export const useLeadRemovalServiceDeleteApiLeadTasksDetachLeadsFromTask = <TData = Common.LeadRemovalServiceDeleteApiLeadTasksDetachLeadsFromTaskMutationResult, TError = unknown, TContext = unknown>(options?: Omit<UseMutationOptions<TData, TError, {
  requestBody: DetachLeadsFromTaskRequest;
}, TContext>, "mutationFn">) => useMutation<TData, TError, {
  requestBody: DetachLeadsFromTaskRequest;
}, TContext>({ mutationFn: ({ requestBody }) => LeadRemovalService.deleteApiLeadTasksDetachLeadsFromTask({ requestBody }) as unknown as Promise<TData>, ...options });
